import _, { last } from 'lodash'
import moment from "moment";
import Zemen from "../UIComponents/ZemenCalendar/zemen";
import {calculateIncomeTax, calculateTaxableEarning, convertCurrency, grossUpEarning} from "../Helpers/salaryCalculator";
import {countDaysBetween} from "../Helpers/dateHelpers/dateFunctions";
import {Parser} from 'expr-eval'
const initialState = {
    payrolls: [],
    distEarnings: [],
    incomeTaxRules: [],
    totalIncome: 0,
    absentDeduction:0,
    taxableIncome: 0,
    incomeTax: 0,
    netPay:0,
    pensionEmployee: 0,
    pensionCompany: 0,
    pf: 0,
    pfCompany:0,
    payrollDate: moment().add(-15, 'days').startOf('month'),
    prevPayrollDate:null,
    runDate: new Date(),
    site: null,
    employmentType: null,
    costCenter:null,
    region: null,
    firstRun: false,
    periodStart: moment(),
    periodEnd: moment(),
    offsetDays: 0,
    calendar: '',
    excluded: [],
    basicAbsentDeduction:0,
    overtimeTotal:0,
    deductServiceHour: true,
    useServiceHours: false,
    ignoreLeaveOnServiceHours: false,
    settings: {},
    unProccesedTimeSheet: [],

};




const oldTaxRules = [
    {
        "start": 0.0,
        "end": 600.0,
        "taxRate": 0.0,
        "deduction": 0.0
    },
    {
        "start": 601.0,
        "end": 1650.0,
        "taxRate": 0.1,
        "deduction": 60.0
    },
    {
        "start": 1651.0,
        "end": 3200.0,
        "taxRate": 0.15,
        "deduction": 142.5
    },
    {
        "start": 3201.0,
        "end": 5250.0,
        "taxRate": 0.2,
        "deduction": 302.5
    },
    {
        "start": 5251.0,
        "end": 7800.0,
        "taxRate": 0.25,
        "deduction": 565.0
    },
    {
        "start": 7801.0,
        "end": 10900.0,
        "taxRate": 0.3,
        "deduction": 955.0
    },
    {
        "start": 10901.0,
        "end": 10000000000.0,
        "taxRate": 0.35,
        "deduction": 1500.0
    }
]


function calculatePayDays (date,periodDaySetting=0, normalPay=0,backPay=0,forwardPay=0){

    if(periodDaySetting>0) {
        return normalPay + backPay + forwardPay
    }
    const m = moment(date);
    const prevMonth  = moment(date).subtract(1,"months");
    const nextMonth  = moment(date).add(1,"months");

    //console.log(prevMonth.format("MMMM"),nextMonth.format("MMMM"))
    return normalPay + backPay/prevMonth.daysInMonth()*m.daysInMonth() + forwardPay/nextMonth.daysInMonth()*m.daysInMonth();

}

function getOTBase(item) {
    switch (item.otBase) {
        case 'basic':
            return item.fullBasicSalary
        case 'gross':
            return item.fullBasicSalary + (item.additionalFixedEarningsOriginal||item.additionalFixedEarnings)
        case 'desiredNet':
            return item.desiredNet || item.fullBasicSalary
        default:
            return item.fullBasicSalary

    }
}

/**
 * Checks if a person's suspension overlaps with a given payroll period.
 * Handles cases where the suspension has no end date (ongoing).
 *
 * @param {object} person - The person's data object, expected to have an 'events' array.
 * @param {string} payrollStartDate - The start date of the payroll period (e.g., 'YYYY-MM-DD').
 * @param {string} payrollEndDate - The end date of the payroll period (e.g., 'YYYY-MM-DD').
 * @returns {boolean} - Returns true if there is a suspension that overlaps, false otherwise.
 */
export function isSuspendedDuringPayroll(person, payrollStartDate, payrollEndDate) {
  if (!person || !person.events || person.events.length === 0) {
    return false;
  }

  // Filter for only 'Suspension' events
  const suspensionEvents = person.events.filter(event => event.eventType === 'Suspension');

  if (suspensionEvents.length === 0) {
    return false;
  }

  // Find the most recent 'Suspension' event by sorting
  const latestSuspension = suspensionEvents.sort((a, b) => {
    // Determine the sorting date for event 'a'
    const dateA = a.endDate ? moment(a.endDate) : moment(a.startDate);
    // Determine the sorting date for event 'b'
    const dateB = b.endDate ? moment(b.endDate) : moment(b.startDate);

    // If both dates are invalid, they are treated as equal
    if (!dateA.isValid() && !dateB.isValid()) {
      return 0;
    }
    // Invalid dates are sorted to the end
    if (!dateA.isValid()) {
      return 1;
    }
    if (!dateB.isValid()) {
      return -1;
    }
    
    // Sort in descending order to get the latest date first
    return dateB.diff(dateA);
  })[0];

  const payrollStart = moment(payrollStartDate);
  const payrollEnd = moment(payrollEndDate);
  const suspensionStartDate = latestSuspension.startDate ? moment(latestSuspension.startDate) : null;
  const suspensionEndDate = latestSuspension.endDate ? moment(latestSuspension.endDate) : null;

  // Check for overlap based on the type of event
  // Case 1: Both start and end dates are present
  if (suspensionStartDate && suspensionEndDate) {
    return suspensionStartDate.isSameOrBefore(payrollEnd, 'day') && suspensionEndDate.isSameOrAfter(payrollStart, 'day')
  }

  // Case 2: Only start date is present (ongoing suspension)
  if (suspensionStartDate && !suspensionEndDate) {
    return suspensionStartDate.isSameOrBefore(payrollEnd);
  }

  // Case 3: Only end date is present (started in the past, ends on a known date)
  if (!suspensionStartDate && suspensionEndDate) {
    return suspensionEndDate.isSameOrAfter(payrollStart, 'day');
  }

  // If neither date is given, it cannot be a valid suspension for our check
  return false;
  
}

export function calculatePayrollItem(item,field,value,taxRules, settings, usedCurrencyRates){
    const newItem = { ...item, [field]: value }

    if(field==='serviceDays') {
        newItem.serviceDaysModified = true
    }

    const baseForAbsentDeduction = settings.absentDeductionDesiredNet && newItem.desiredNet
        ? newItem.desiredNet
        : newItem.fullBasicSalary;

    if(field!=='calculated'&&field!=="emailSent") {
        newItem.emailSent = false
        newItem.publishId = 0
    }

    // Check for full period suspension at the start of calculation
    // if (field === 'calculated' || field === 'normalPayDays') {
    //     if (newItem.events && newItem.events.length > 0) {
    //         const suspensions = newItem.events.filter(event => 
    //             event.eventType === 'Suspension' && 
    //             moment(event.startDate).isSameOrBefore(moment(newItem.periodStart)) &&
    //             (!event.endDate || moment(event.endDate).isAfter(moment(newItem.periodEnd)))
    //         )
    //         console.log({suspensions})
            
    //         if (suspensions.length > 0) {
    //             newItem.status = 'Held'
                
    //             return newItem
    //         }
    //     }
    // }

    if(field==='normalPayDays') {
        newItem.monthlyHours =  newItem.employmentType!=="Casual"?(!newItem.useServiceHours?newItem.fullMonthlyHours*newItem.normalPayDays/newItem.totalDaysInPayPeriod:newItem.dailyServiceHour*(Math.min(newItem.normalPayDays,newItem.daysInMonthForExpectedHours))):newItem.normalPayDays*newItem.dailyServiceHour; //get from database

        // newItem.monthlyHours = newItem.employmentType !== "Casual" ? newItem.fullMonthlyHours * newItem.normalPayDays / newItem.totalDaysInPayPeriod : newItem.payDays * 8
        newItem.backPayDays = Math.max(newItem.normalPayDays - newItem.totalDaysInPayPeriod, newItem.backPayDays);
        //newItem.adjustedDays = newItem.normalPayDays
    }

    if(field==='normalPayDays'&&!newItem.fromTimeAttendance) {

        newItem.hoursWorked =  newItem.monthlyHours
        newItem.actualHoursWorked = newItem.monthlyHours

    }


    if (field === 'basicAbsentDeduction') { 
        // newItem.basicAbsentDeduction = +value
        // newItem.basicAbsentDeduction = +Math.max((newItem.monthlyHours - newItem.hoursWorked) * ((Math.min(newItem.basicSalary,newItem.fullBasicSalary)+(newItem.otBase==='gross'?newItem.additionalFixedEarnings:0))/ newItem.monthlyHours), 0).toFixed(1);

         const d = (Math.min(newItem.basicSalary, baseForAbsentDeduction) + (newItem.otBase === 'gross' ? newItem.additionalFixedEarnings : 0))
        newItem.hoursWorked = d>0? newItem.monthlyHours - (newItem.basicAbsentDeduction * newItem.monthlyHours) / d : 0
    

        
    }

    if(field==='normalPayDays'||field==='calculated'||field==='backPayDays'||field==='forwardPayDays'||field==='basicSalaryAdjustment') {
       // newItem.payDays = newItem.normalPayDays


        newItem.normalPayDays = Math.min(newItem.normalPayDays,newItem.totalDaysInPayPeriod);
       // newItem.payDays = newItem.normalPayDays
        // backpay logic here
       // moment()

        newItem.payDays = calculatePayDays(newItem.payrollDate,newItem.periodDaySetting,newItem.normalPayDays,newItem.backPayDays,newItem.forwardPayDays)

        
        // newItem
        
        if(newItem.employmentType!=="Casual"){
            newItem.basicSalary = +((newItem.fullBasicSalary / newItem.totalDaysInPayPeriod) * newItem.payDays).toFixed(5) + (newItem.basicSalaryAdjustment?convertCurrency(newItem.basicSalaryAdjustment,newItem.basicCurrency,usedCurrencyRates):0)
        }
        newItem.totalWorkDays =  Math.min(newItem.payDays,newItem.fullWorkDays)
        newItem.daysWorked = Math.min(newItem.payDays,newItem.fullWorkDays)-newItem.absentDays+ newItem.penaltyAbsentDays-newItem.leaveDays
        if(!newItem.serviceDaysModified) {
            newItem.serviceDays = newItem.daysWorked + (newItem.ignoreLeaveOnServiceHours?newItem.leaveDays:0)
        }

        // if(field!=='calculated') {
        //   //  newItem.hoursWorked = newItem.monthlyHours// Math.min(newItem.monthlyHours,newItem.hoursWorked);
        // }
        // if(field!=='calculated'&&!newItem.fromTimeAttendance) {
        //     newItem.hoursWorked = (+(newItem.monthlyHours / newItem.totalWorkDays).toFixed(5) * (newItem.daysWorked + newItem.leaveDays))
        //
        // }
        const basicSalaryTotal = newItem.fullBasicSalary + (newItem.basicSalaryAdjustment ? convertCurrency(newItem.basicSalaryAdjustment, newItem.basicCurrency, usedCurrencyRates) : 0);
        
        newItem.payrollFixedEarnings.map(ta=>{
          
            if (ta.fullValue === ta.originalValue) {
               
        
                const tempValue = (ta.fullValue / newItem.totalDaysInPayPeriod) * newItem.payDays;
                
                if (ta.dayBased) {
                    ta.entitledDays = newItem.payDays;
                    ta.value = +((tempValue).toFixed(5));
                }
                
                if (ta.valueType === 'Percentage') {
                    ta.value = newItem.fullBasicSalary ? (ta.dayBased ? tempValue : ta.fullValue) / newItem.fullBasicSalary * basicSalaryTotal : 0;
                }
         
            }
        })

        newItem.payrollFixedDeductions.map(ta => {
           
            if (ta.fullValue === ta.originalValue) {
                const tempValue = +(ta.fullValue / newItem.totalDaysInPayPeriod) * newItem.payDays;
               if (ta.dayBased) {
                   ta.value = +((tempValue).toFixed(5));
               }
               if(ta.valueType==='Percentage') {
                ta.value = newItem.fullBasicSalary ? (ta.dayBased ? tempValue : ta.fullValue) / newItem.fullBasicSalary * basicSalaryTotal : 0;
            }
           }
        })

        newItem.payrollFixedExpenses.map(ta=>{
            if (ta.fullValue === ta.originalValue) {
                const tempValue = +(ta.fullValue / newItem.totalDaysInPayPeriod) * newItem.payDays;
                if (ta.dayBased) {
                    ta.value = +((tempValue).toFixed(5));
                }
                if(ta.valueType==='Percentage') {
                    ta.value = newItem.fullBasicSalary ? (ta.dayBased ? tempValue : ta.fullValue) / newItem.fullBasicSalary * basicSalaryTotal : 0;
                }
            }
        })
        newItem.fixedDeductionsTotals= newItem.payrollFixedDeductions.reduce((sum, cv) => sum + cv.value, 0);
 
        newItem.fixedExpensesTotals= newItem.payrollFixedExpenses.reduce((sum, cv) => sum + cv.value, 0);

        newItem.empPension = newItem.payrollFixedDeductions.reduce((sum,cv)=>cv.deductionType === 'EmpPension'? sum+cv.value:sum,0)||0
        newItem.companyPension = newItem.payrollFixedExpenses.reduce((sum,cv)=>cv.type === 'CompanyPension'? sum+cv.value:sum,0)||0
        newItem.pf =  newItem.payrollFixedDeductions.reduce((sum,cv)=>cv.deductionType === 'PF'? sum+cv.value:sum,0)||0
        newItem.companyPf= newItem.payrollFixedExpenses.reduce((sum,cv)=>cv.type === 'CompanyPF'? sum+cv.value:sum,0)||0


        // newItem.payrollDeductions.map(ta=>{
        //     //  if(ta.value===ta.originalValue)
        //     if(ta.dayBased) {
        //         ta.value = (ta.fullValue / newItem.totalDaysInPayPeriod) * newItem.payDays;
        //     }
        // })
    }
    // if(newItem.employmentType !== 'Casual')
    // {
        // if(field==='fromTimeAttendance') {
        //     console.log("xxx fromTimeAttendance")
        // }

// if(field==='payrollFixedEarnings')
// {
//     newItem.payrollFixedEarnings.map(ta=>{
//         if(ta.fullValue===ta.originalValue) {
//             if (ta.dayBased) {
//                 //   ta.entitledDays = newItem.payDays
//                 ta.value = (ta.originalValue / newItem.totalDaysInPayPeriod) * ta.entitledDays;
//                // ta.fullValue = ta.value
//             }
//          }
//     })
// }



        if(field==='daysWorked'||field==='payDays') {
            newItem.absentDays = Math.max(newItem.totalWorkDays - newItem.daysWorked,0)
           // newItem.fromTimeAttendance = false
            if(+newItem.fromTimeAttendance!==+newItem.hoursWorked) {
                newItem.hoursWorked = newItem.monthlyHours / newItem.totalWorkDays * (newItem.daysWorked + newItem.leaveDays)
                newItem.actualHoursWorked =  newItem.hoursWorked
            }
            if(!newItem.serviceDaysModified) {
                newItem.serviceDays = newItem.daysWorked + (newItem.ignoreLeaveOnServiceHours?newItem.leaveDays:0)
            }
        }
        if(field==='absentDays') {
            newItem.daysWorked = Math.max(newItem.totalWorkDays - newItem.absentDays + newItem.penaltyAbsentDays - newItem.leaveDays,0)
            if(+newItem.fromTimeAttendance!==+newItem.hoursWorked) {
                newItem.hoursWorked = (+(newItem.monthlyHours / newItem.totalWorkDays).toFixed(5) * (newItem.daysWorked + newItem.leaveDays))
                newItem.actualHoursWorked =  newItem.hoursWorked
             // console.log(newItem.hoursWorked,"hh")
            }
            if(!newItem.serviceDaysModified) {
                newItem.serviceDays = newItem.daysWorked + (newItem.ignoreLeaveOnServiceHours?newItem.leaveDays:0)
            }
            }

    if(field==='penaltyAbsentDays') {
      //  console.log(newItem.penaltyAbsentDays)
        newItem.daysWorked = Math.max(newItem.totalWorkDays - newItem.absentDays +  newItem.penaltyAbsentDays - newItem.leaveDays,0)
       // if(+newItem.fromTimeAttendance!==+newItem.hoursWorked) {
            newItem.hoursWorked = (+(newItem.monthlyHours / newItem.totalWorkDays).toFixed(5) * (newItem.daysWorked - newItem.penaltyAbsentDays + newItem.leaveDays))
           // newItem.actualHoursWorked =  newItem.hoursWorked
            // console.log(newItem.hoursWorked,"hh")
        //}
        if(!newItem.serviceDaysModified) {
            newItem.serviceDays = newItem.daysWorked + (newItem.ignoreLeaveOnServiceHours?newItem.leaveDays:0)
        }
    }


        if(field==='leaveDays') {
            newItem.leaveDaysTaken =    (newItem.leaveDaysTakenPrevious +newItem.leaveDays) || 0
            newItem.daysWorked = newItem.totalWorkDays - newItem.absentDays + newItem.penaltyAbsentDays - newItem.leaveDays
            if(+newItem.fromTimeAttendance!==+newItem.hoursWorked) {
                newItem.actualHoursWorked = newItem.monthlyHours - (newItem.monthlyHours / newItem.payDays) * newItem.leaveDays
            }         //   newItem.hoursWorked = Math.min(newItem.fromTimeAttendance + (8 * newItem.leaveDays), newItem.monthlyHours)
         //    if(newItem.fromTimeAttendance) {
         //        newItem.hoursWorked = Math.min(+newItem.fromTimeAttendance + (8 * newItem.leaveDays), newItem.monthlyHours)
         //    }
         if(!newItem.serviceDaysModified) {
             newItem.serviceDays = newItem.daysWorked + (newItem.ignoreLeaveOnServiceHours?newItem.leaveDays:0)
         }
        }
        // if(field==='hoursWorked '||field==='daysWorked') {
        //     newItem.hoursWorked =   newItem.hoursWorked <180?  newItem.hoursWorked:180
        // }
        if(newItem.deductTransportIfAbsent)
        {
            const  dayBasedAllowanceTotal = newItem.payrollFixedEarnings.filter(e=>e.dayBased).reduce((sum, cv) => sum + cv.value, 0)
        //   console.log(dayBasedAllowanceTotal)
            //  const transportAllowance = newItem.payrollFixedEarnings.find(e=>e.earningType&&e.earningType==="Transport Allowance")
           //  if(transportAllowance)
           //  {
           //      transportAllowance.value = transportAllowance.value -(transportAllowance.value/newItem.totalWorkDays * (+newItem.leaveDays+(+newItem.absentDays)))
           //   //   newItem.payrollFixedEarnings.fin
           //      newItem.payrollFixedEarnings = [...newItem.payrollFixedEarnings.filter(a=>a!==transportAllowance),transportAllowance]
           //
           //  }
            newItem.additionalEarningsAbsentDeduction=  dayBasedAllowanceTotal/newItem.totalWorkDays * (Math.floor(+newItem.leaveDays)+(Math.floor(+newItem.absentDays)))
        } else {
            newItem.additionalEarningsAbsentDeduction = 0;
        }


        if(newItem.employmentType!=="Casual") {
            newItem.basicAbsentDeduction = newItem.monthlyHours? +Math.max((newItem.monthlyHours - newItem.hoursWorked) * ((Math.min(newItem.basicSalary, baseForAbsentDeduction)+(newItem.otBase==='gross'?newItem.additionalFixedEarnings:0))/ newItem.monthlyHours), 0).toFixed(1):0;
        }       // newItem.basicAbsentDeduction = newItem.basicAbsentDeduction >0?newItem.basicAbsentDeduction:0;
else {
            newItem.basicAbsentDeduction = 0
           // newItem.basicAbsentDeduction = +Math.max((newItem.monthlyHours - newItem.hoursWorked) * (Math.min(newItem.basicSalary,newItem.fullBasicSalary) / newItem.monthlyHours), 0).toFixed(2);
        }
    
   
        newItem.absenceDeduction =   (newItem.additionalEarningsAbsentDeduction||0)+(newItem.basicAbsentDeduction||0)


   // }
    // else {
    //     //newItem.daysWorked = item.da
    //     newItem.absenceDeduction = 0
    // }
   // console.log("bonues",newItem.bonuses)
    newItem.earnedSalary= newItem.employmentType==='Casual'? newItem.fullBasicSalary* newItem.daysWorked : (newItem.basicSalary - (settings.absentDeductionAfterTax?0:newItem.basicAbsentDeduction))


    // newItem.bonuses = newItem.bonuses.map(b=>{ return {...b,value:b.extraData.netValue?b.extraData.netValue*2:b.value} })

  

    const transportAllowances =  newItem.payrollFixedEarnings.filter(cv=>cv.earningType&&cv.earningType.replace(/\s+/g, '').toLowerCase().includes('transportallowance'))

    newItem.additionalFixedEarnings = newItem.payrollFixedEarnings.reduce((sum, cv) => sum + cv.value, 0)
    newItem.fixedDeductionsTotals = newItem.payrollFixedDeductions.reduce((sum, cv) => sum + cv.value, 0)
    newItem.fixedExpensesTotals = newItem.payrollFixedExpenses.reduce((sum, cv) => sum + cv.value, 0)
    newItem.serviceHours =  (newItem.serviceDays * newItem.dailyServiceHour)-(newItem.deductServiceHour?(newItem.missedHours||0):0)

    // console.log(newItem.monthlyOTHours, getOTBase(newItem))
    const hourlyWage = newItem.employmentType!=='Casual'? getOTBase(newItem)/newItem.monthlyOTHours:newItem.fullBasicSalary/8;
try {
    newItem.overtimeTotal = newItem.overtimes.reduce((sum,cv)=>sum+cv.hrs*cv.rate*(hourlyWage),0)
}
catch (e) {
    console.log(newItem, e)
}



    if(newItem.omitTransportAllowance) {
        const  transportAllowance = newItem.payrollFixedEarnings.filter(e=>e.earningType&&e.earningType.toLowerCase().replace(/\s+/g, '').includes("transportallowance")).reduce((sum, cv) => sum + cv.value, 0)
        newItem.additionalFixedEarnings = newItem.payrollFixedEarnings.reduce((sum, cv) => sum + cv.value, 0) - transportAllowance
    }


    
    const totalTransportAllowance = transportAllowances.reduce((sum,cv)=>sum+cv.value,0)
    // console.log("tt",totalTransportAllowance)
    const limit = (_.maxBy(transportAllowances.filter(t=>t.taxOption==='TaxableWithLimits'),'limitByValue')||{limitByValue:0}).limitByValue;
// console.log('limi',limit,transportAllowances)

    const taxableTransportAllowance = Math.max(totalTransportAllowance- limit,0);



    newItem.taxableEarnings = Math.max(newItem.payrollFixedEarnings
        .filter(e=>!transportAllowances.includes(e))
        .reduce((sum, cv)=>sum+calculateTaxableEarning(cv,newItem.basicSalary),0) - ((settings.absentDeductionAfterTax&&newItem.additionalEarningsAbsentDeduction)||0),0) + taxableTransportAllowance


    newItem.bonuses = newItem.bonuses.map(b=>{ return {...b,value:b.extraData&&b.extraData.netValue?0:b.value} })



    newItem.bonusesTotal = newItem.bonuses.reduce((sum,cv)=>sum+(+cv.value),0)
    newItem.taxableBonuses = newItem.bonuses.reduce((sum,cv)=>sum+calculateTaxableEarning(cv,newItem.basicSalary),0)



    //  if(newItem.employmentType !== 'Casual') {
        newItem.taxableIncome = newItem.earnedSalary + newItem.overtimeTotal + newItem.taxableEarnings + newItem.taxableBonuses


           newItem.bonuses = newItem.bonuses.map(b=>{ return {...b,value:b.extraData&& b.extraData.netValue?grossUpEarning({netValue:b.extraData.netValue,prevGross:newItem.taxableIncome,taxRules}):b.value} })
           
           
    if(newItem.payrollFixedEarnings.some(s=>s.valueType==='Net'))   {
            newItem.payrollFixedEarnings.map(ta=>{
       
          
            if (ta.valueType === 'Net') {
               
        
                const tempValue = (ta.originalValue / newItem.totalDaysInPayPeriod) * ta.entitledDays;
                
              
                    const net =  (ta.dayBased ? tempValue : ta.originalValue) 
                    const gross = grossUpEarning({netValue:net,prevGross:newItem.taxableIncome,taxRules})
                    ta.value = gross
                
            }
        })

        newItem.additionalFixedEarnings = newItem.payrollFixedEarnings.reduce((sum, cv) => sum + cv.value, 0)
           
        if(newItem.omitTransportAllowance) {
            const  transportAllowance = newItem.payrollFixedEarnings.filter(e=>e.earningType&&e.earningType.toLowerCase().replace(/\s+/g, '').includes("transportallowance")).reduce((sum, cv) => sum + cv.value, 0)
            newItem.additionalFixedEarnings = newItem.payrollFixedEarnings.reduce((sum, cv) => sum + cv.value, 0) - transportAllowance
        }
        newItem.taxableEarnings = Math.max(newItem.payrollFixedEarnings
            .filter(e=>!transportAllowances.includes(e))
            .reduce((sum, cv)=>sum+calculateTaxableEarning(cv,newItem.basicSalary),0) - ((settings.absentDeductionAfterTax&&newItem.additionalEarningsAbsentDeduction)||0),0) + taxableTransportAllowance
    
    }
           
           newItem.bonusesTotal = newItem.bonuses.reduce((sum,cv)=>sum+(+cv.value),0)
    newItem.taxableBonuses = newItem.bonuses.reduce((sum,cv)=>sum+calculateTaxableEarning(cv,newItem.basicSalary),0)
const benefitInKindTotal =  newItem.payrollFixedEarnings.reduce((sum,cv)=>sum+(( cv.earningType.toLowerCase().replace(/\s+/g, '').includes('benefitinkind'))?calculateTaxableEarning(cv,newItem.basicSalary):0),0) + newItem.bonuses.reduce((sum,cv)=>sum+(( cv.type.toLowerCase().replace(/\s+/g, '').includes('benefitinkind'))?calculateTaxableEarning(cv, newItem.basicSalary):0),0)


    newItem.additionalEarningsTotal = newItem.additionalFixedEarnings + newItem.bonusesTotal + newItem.overtimeTotal - benefitInKindTotal

        newItem.taxableIncome = newItem.earnedSalary + newItem.overtimeTotal + newItem.taxableEarnings + newItem.taxableBonuses
        newItem.nonTaxableIncome = newItem.additionalFixedEarnings + newItem.bonusesTotal - newItem.taxableEarnings - newItem.taxableBonuses
        newItem.totalIncome = (newItem.employmentType !== 'Casual'? newItem.basicSalary:newItem.earnedSalary) + newItem.additionalEarningsTotal//newItem.taxableIncome + newItem.nonTaxableIncome
   // }
    // else {
    //     newItem.taxableIncome = newItem.earnedSalary + newItem.overtimeTotal + newItem.taxableEarnings + newItem.taxableBonuses
    //     newItem.nonTaxableIncome = newItem.additionalFixedEarnings + newItem.bonusesTotal - newItem.taxableEarnings - newItem.taxableBonuses
    //     newItem.totalIncome = newItem.earnedSalary + newItem.additionalEarningsTotal//newItem.taxableIncome + newItem.nonTaxableIncome
    //
    // }

    // if(newItem.taxableIncome<0)
    // console.log(newItem.fullName, newItem.basicSalary, newItem.earnedSalary,newItem.basicAbsentDeduction)

   // newItem.incomeTax = newItem.extraIncomeTax calculateIncomeTax(newItem.taxableIncome, taxRules) + (newItem.extraIncomeTax || 0)


    // if(field==='bonuses'||field==='calculated') {
        const additionalIncomeTaxes = []
        newItem.bonuses.filter(b=>b.type==='backPay').forEach(bp=>{
            const appliedTaxRules = moment(bp.extraData.payrollDate)>=moment("07-01-2025")?taxRules:oldTaxRules
            // console.log({bp,val:calculateIncomeTax(bp.extraData.taxableIncome+bp.value, taxRules) - bp.extraData.incomeTax})
            additionalIncomeTaxes.push(calculateIncomeTax(bp.extraData.taxableIncome+bp.value, appliedTaxRules) - bp.extraData.incomeTax)
        })

        newItem.bonuses.filter(b=>b.type==='bonus').forEach(bp=>{
            if(bp.extraData.collection && bp.extraData.collection.length) {
                const includeCurrent = bp.extraData.includeCurrentMonth !== false
                const totalMonths = bp.extraData.collection.length + (includeCurrent ? 1 : 0)
                const sharePerMonth = bp.value / totalMonths
                const previousMonthsTax = bp.extraData.collection.reduce((sum, cv) => sum + (calculateIncomeTax(cv.taxableIncome + sharePerMonth, moment(cv.payrollDate||"08-01-2025")>=moment("07-01-2025")?taxRules:oldTaxRules) - cv.incomeTax), 0)
                if (includeCurrent) {
                    const currentMonthBaseTax = calculateIncomeTax(newItem.taxableIncome, taxRules, {context:newItem})
                    const currentMonthTax = calculateIncomeTax(newItem.taxableIncome + sharePerMonth, taxRules, {context:newItem}) - currentMonthBaseTax
                    additionalIncomeTaxes.push(previousMonthsTax + currentMonthTax)
                } else {
                    additionalIncomeTaxes.push(previousMonthsTax)
                }
            }   else {
                additionalIncomeTaxes.push(calculateIncomeTax(newItem.taxableIncome+bp.value, taxRules) - newItem.incomeTax)
            }

        })

        // console.log({additionalIncomeTaxes})
    


      //console.log({extraIncome: newItem.extraIncomeTax})
    newItem.additionalIncomeTax =  additionalIncomeTaxes.reduce((sum,cv)=>sum+cv,0)
    if(newItem.additionalIncomeTax<0 && newItem.employeeId === 288) {
        console.log(newItem)
    }

    //   console.log(newItem.additionalIncomeTax , "addiiotnaltax")
        newItem.incomeTax =   calculateIncomeTax(newItem.taxableIncome, taxRules, {context:newItem}) +    ( newItem.additionalIncomeTax||0)    + (newItem.extraIncomeTax || 0)

    //console.log(newItem.incomeTax, newItem.additionalIncomeTax)

    const paybackTax =  newItem.bonuses.reduce((sum,cv)=>sum+(cv.taxOption==='TaxableWithPayback'?calculateTaxableEarning(cv,newItem.basicSalary):0),0)

    if(paybackTax>=0) {
        const withOut =    calculateIncomeTax(newItem.taxableIncome-paybackTax, taxRules, {context:newItem})+ (newItem.extraIncomeTax || 0) +    newItem.additionalIncomeTax
        const val = newItem.incomeTax - withOut;
        const index = newItem.payrollDeductions.findIndex(i=>i.type==='tax')
        const newRoles = newItem.payrollDeductions.slice(0); // Create a shallow copy of the roles
        if(index>=0) {
            newRoles[index] = {type: "tax", value:val, name: "Tax Paid on behalf", cash: true};
        }// Set the new value
        else if(val>0) {
            newRoles.push({type: "tax", value:val, name: "Tax Paid on behalf", cash: true})
        }
        // console.log({paybackTax,newRoles})

        newItem.payrollDeductions.length =0
        newItem.payrollDeductions.push(...newRoles)

    } else {
        const index = newItem.payrollDeductions.findIndex(i=>i.type==='tax')
        const newRoles = newItem.payrollDeductions.slice(0); // Create a shallow copy of the roles
        if(index>=0) {
            newRoles[index] = {type: "tax", value:0, name: "Tax Paid on behalf", cash: true};
        }// Set the new value
        newItem.payrollDeductions.length =0
        newItem.payrollDeductions.push(...newRoles)
    }



    const taxableCoveredEarnings =  newItem.payrollFixedEarnings.reduce((sum,cv)=>sum+(cv.taxOption==='TaxCovered'?calculateTaxableEarning(cv,newItem.basicSalary):0),0) + newItem.bonuses.reduce((sum,cv)=>sum+(cv.taxOption==='TaxCovered'?calculateTaxableEarning(cv,newItem.basicSalary):0),0)
    const taxableBenefit =  newItem.payrollFixedEarnings.reduce((sum,cv)=>sum+((cv.taxOption==='TaxCovered' && cv.earningType.toLowerCase().replace(/\s+/g, '').includes('benefitinkind'))?calculateTaxableEarning(cv,newItem.basicSalary):0),0) + newItem.bonuses.reduce((sum,cv)=>sum+((cv.taxOption==='TaxCovered' && cv.type.toLowerCase().replace(/\s+/g, '').includes('benefitinkind'))?calculateTaxableEarning(cv,newItem.basicSalary):0),0)


    const withOut = calculateIncomeTax(newItem.taxableIncome -  taxableCoveredEarnings, taxRules,{context:newItem})+ (newItem.extraIncomeTax || 0) + newItem.additionalIncomeTax
    newItem.coveredIncomeTax =newItem.incomeTax - withOut;

    const withOutBenefit = calculateIncomeTax(newItem.taxableIncome -  taxableBenefit, taxRules,{context:newItem})+ (newItem.extraIncomeTax || 0) + newItem.additionalIncomeTax
    // the rule say if the tax of benefit in kind is greater than 10% of basic salary use 10% of basic salary

   // const benefitTax = calculateIncomeTax(taxableBenefit, taxRules)
   // console.log(newItem.employee.name, taxableBenefit, newItem.taxableIncome -  taxableBenefit, newItem.incomeTax-withOutBenefit, withOutBenefit)

    if(taxableBenefit && newItem.basicSalary*0.1<=(newItem.incomeTax-withOutBenefit))
    {
        //console.log({x:newItem.incomeTax-withOutBenefit})
        newItem.coveredIncomeTax = (newItem.incomeTax - withOut) - (newItem.incomeTax -withOutBenefit) + newItem.basicSalary*0.1
        // console.log(newItem.coveredIncomeTax)
        newItem.incomeTax = withOutBenefit + newItem.coveredIncomeTax
    }



    // }

   // console.log(newItem.payrollDeductions)
   if(settings.startNewTaxRuleAfterDays>=0&&newItem.normalPayDays >0&&moment(newItem.payrollDate) < moment("08-08-2025")) {
     

    const cuttOffDays = moment(newItem.payrollDate) < moment("07-01-2025")? newItem.normalPayDays: (newItem.normalPayDays !== newItem.totalDaysInPayPeriod && moment(newItem.employee.startDate) > moment("07-01-2025"))?  Math.max(0,moment("07-01-2025").add(settings.startNewTaxRuleAfterDays, 'days').diff(moment(newItem.employee.startDate), 'days')): settings.startNewTaxRuleAfterDays
    
    // console.log({cuttOffDays, name: newItem.employee.name})

//tax poration because of new rulle apply date 7 days old 24 days new in july 2025

const oldIncomeTax = calculateIncomeTax(newItem.taxableIncome, oldTaxRules,{context:newItem})
const newIncomeTax = calculateIncomeTax(newItem.taxableIncome, taxRules, {context:newItem}) 

 newItem.incomeTax = ((oldIncomeTax / newItem.normalPayDays * cuttOffDays) + (newIncomeTax / newItem.normalPayDays * (newItem.normalPayDays-cuttOffDays))) +   ( newItem.additionalIncomeTax||0)    + (newItem.extraIncomeTax || 0)

 
//  console.log({oldIncomeTax, new:newItem.incomeTax })

}

    newItem.payrollLoanSettlement = newItem.payrollDeductions.reduce((sum,cv)=>cv.type==='loan'?sum+cv.value:sum,0)
    newItem.payrollAdvanceSettlement = newItem.payrollDeductions.reduce((sum,cv)=>cv.type==='advance'?sum+cv.value:sum,0)
    newItem.payrollDeductionTotal = newItem.payrollDeductions.reduce((sum,cv)=>(!cv.cash && cv.valueType !== 'NetPercentage')?sum+cv.value:sum,0)// - newItem.payrollAdvanceSettelment- newItem.payrollLoanSettlement; //loan or advances are deducted from cash but not a netpay account
    newItem.payrollDeductionTotalCash = newItem.payrollDeductions.reduce((sum,cv)=>(cv.cash && cv.valueType !== 'NetPercentage')?sum+cv.value:sum,0)// - newItem.payrollAdvanceSettelment- newItem.payrollLoanSettlement; //loan or advances are deducted from cash but not a netpay account
    newItem.totalDeduction =  newItem.fixedDeductionsTotals +  newItem.absenceDeduction + newItem.incomeTax +  newItem.payrollDeductionTotal
    newItem.fixedDeductionsTotalsAndIncomeTax = newItem.fixedDeductionsTotals + newItem.incomeTax
    newItem.grossIncome = newItem.earnedSalary + newItem.additionalEarningsTotal - newItem.additionalEarningsAbsentDeduction
    if(newItem.employmentType !== 'Casual') {
        newItem.netPay = newItem.basicSalary + newItem.additionalEarningsTotal - newItem.totalDeduction
    }
    else {
        newItem.netPay = newItem.earnedSalary + newItem.additionalEarningsTotal - newItem.totalDeduction
    }
    // Process NetPercentage deductions (valueType === 'NetPercentage') - calculate as percentage of net pay
    const netPctDeductions = newItem.payrollDeductions.filter(d => d.valueType === 'NetPercentage' && d.value > 0);
    if (netPctDeductions.length > 0) {
        console.log("netPctDeductions", newItem.payrollDeductions)
        const nonNetPct = newItem.payrollDeductions.filter(d => !(d.valueType === 'NetPercentage' && d.value > 0));
        const netPctMap = new Map();
        netPctDeductions.forEach(d => {
            const percentage = d.originalValue !== undefined ? d.originalValue : d.value;
            const processed = {
                ...d,
                type: (d.type || '').toLowerCase(),
                value: percentage * newItem.netPay,
                cash: true,
                originalValue: percentage
            };
            netPctMap.set(d.id, processed);
        });
        newItem.payrollDeductions = [...nonNetPct, ...Array.from(netPctMap.values())];
        console.log({netPctDeductions, "newItempayrollDeductions":newItem.payrollDeductions})
        // Recalculate payrollDeductionTotalCash with updated values
        newItem.payrollDeductionTotalCash = newItem.payrollDeductions.reduce((sum, cv) => cv.cash ? sum + cv.value : sum, 0);
    }
    newItem.cash =  Math.max(( newItem.payGross?newItem.grossIncome:newItem.netPay) - newItem.payrollDeductionTotalCash + (newItem.coveredIncomeTax||0), 0)
    newItem.totalDeductionIncludingCash = newItem.totalDeduction + newItem.payrollDeductionTotalCash

    newItem.outstandingLoan =  newItem.prevOutstandingLoan- (newItem.payrollLoanSettlement +  newItem.payrollAdvanceSettlement)

    if(newItem.costCenterCosts&&newItem.costCenterCosts.length) {
        const cs = []
        const costs =  _.groupBy(newItem.costCenterCosts,'costCenterCode')
        Object.keys(costs).map((key, val)=> {
            const taxRule = taxRules.find(r=>newItem.taxableIncome >= r.start && newItem.taxableIncome<=r.end)
            const  totalIncome =  costs[key].filter(c=>c.type==='Earnings').reduce((sum, cv)=>sum+cv.value,0)

            const  taxableIncome =  costs[key].filter(c=>c.type==='Earnings').reduce((sum, cv)=>sum+calculateTaxableEarning(cv,newItem.basicSalary),0)

            const incomeTax = newItem.incomeTax - calculateIncomeTax(newItem.taxableIncome- taxableIncome, taxRules ,{context:newItem, taxRule})
            const costCenterCashDeduction  = newItem.payrollDeductions.reduce((sum,cv)=>(cv.cash&&cv.costCenterCode===key)?sum+cv.value:sum,0)||0
            cs.push({
                totalIncome,
                costCenterCode: key,
                taxableIncome,
                incomeTax,
                netPay: totalIncome-incomeTax,
                cash: totalIncome-incomeTax-costCenterCashDeduction

            })

        })
        cs.push({
            totalIncome: newItem.totalIncome - cs.reduce((sum,cv)=>sum+cv.totalIncome,0),
            costCenterCode: newItem.costCenterCode,
            taxableIncome: newItem.taxableIncome - cs.reduce((sum,cv)=>sum+cv.taxableIncome,0),
            incomeTax: newItem.incomeTax - cs.reduce((sum,cv)=>sum+cv.incomeTax,0),
            netPay: newItem.netPay - cs.reduce((sum,cv)=>sum+cv.netPay,0),
            cash: newItem.cash- cs.reduce((sum,cv)=>sum+cv.cash,0)
        })
        // console.log({cs})
        newItem.costCenterItems = cs


    }

    // Calculate remarks
    newItem.remarks = settings.lastMonthPayrollFound? calculateRemarks(newItem):[];

    // console.log('newItem',newItem)


    return newItem

}

export function calculatePayrollTotals(payrollsFull,site,employmentType,selectedStatus,costCenter) {
    const payrolls = payrollsFull.filter(p=>(!site||p.siteName===site)&&(!employmentType||p.employmentType===employmentType)&&(!selectedStatus||p.status===selectedStatus)&&(!costCenter||p.costCenterCode===costCenter));
 // console.log(payrolls.filter(p=>!p.empPension))
    // if(site || employmentType) {
   //   run = {...run, description:  `Only ${site?`${site} site`:''} ${!!employmentType&&employmentType} Employees`}
   // }

   return {
       totalIncome: payrolls.reduce((sum, cv) => sum + cv.totalIncome, 0),
       absentDeduction: payrolls.reduce((sum, cv) => sum + cv.absenceDeduction, 0),
       taxableIncome: payrolls.reduce((sum, cv) => sum + cv.taxableIncome, 0),
       incomeTax: payrolls.reduce((sum, cv) => sum + cv.incomeTax, 0),
       netPay: payrolls.reduce((sum, cv) => sum + cv.netPay, 0),
       pensionEmployee: payrolls.reduce((sum, cv) => sum + (cv.empPension || 0), 0),
       pensionCompany: payrolls.reduce((sum, cv) => sum + cv.companyPension, 0),
       pf: payrolls.reduce((sum, cv) => sum + cv.pf, 0),
       pfCompany: payrolls.reduce((sum, cv) => sum + cv.companyPf, 0),
       cash: payrolls.reduce((sum, cv) => sum + cv.cash, 0),
       cashSettlement: payrolls.reduce((sum, cv) => sum + cv.payrollDeductionTotalCash, 0),
       advanceSettlement: payrolls.reduce((sum, cv) => sum + cv.payrollAdvanceSettlement, 0),
       loanSettlement: payrolls.reduce((sum, cv) => sum + cv.payrollLoanSettlement, 0),
       payrollCount: payrolls.length,
       basicAbsentDeduction: payrolls.reduce((sum, cv) => sum + cv.basicAbsentDeduction, 0),
       overtimeTotal: payrolls.reduce((sum, cv) => sum + cv.overtimeTotal, 0),
   }

}

function getRemaining (ref,loans,deduct=0) {
    if(ref >=0 && loans) {
        const loan = loans.find(l=>l.id===ref)
        if(loan) {
            return loan.disburesedAmount  - loan.repayedAmount
        }
    }
    return 0;
}

function calculateRemarks(item) {
    let remarks = [];

    if (!item.lastMonthPay) {
        remarks.push({
            type: 'info',
            text: `👶 New Employee | ${((v) => v % 1 === 0 ? v : v.toFixed(2))(item.fullBasicSalary || item.basicSalary || 0)} ${item.basicCurrency || 'ETB'} from ${moment((item.employee && item.employee.startDate) || item.startDate).format('MMM-DD')}`,
            class: 'newEmployee'
        });
    } else {
        // Cash difference more than 20%
        const cashDiff = ((item.cash - item.lastMonthPay.cash) / item.lastMonthPay.cash) * 100;
        const lastMonthProrated = item.lastMonthPay.basicSalary !== item.lastMonthPay.fullBasicSalary
        if (Math.abs(cashDiff) > 20 && !lastMonthProrated) {
            remarks.push({
                type: 'check',
                text: `💰 ${cashDiff > 0 ? '+' : ''}${cashDiff.toFixed(0)}% from last`,
                class: 'netPayOutlier'
            });
        }

        if(lastMonthProrated && cashDiff>2) {
             remarks.push({
                type: 'info',
                text: `💰 ${cashDiff > 0 ? '+' : ''}${cashDiff.toFixed(0)}% Last month prorated`,
                class: 'netPayOutlier'
            });
        }

        // Any basic salary difference
        const basicDiff = ((item.salaryInBasicCurrency- item.lastMonthPay.salaryInBasicCurrency) / item.lastMonthPay.salaryInBasicCurrency) * 100;
        if (Math.abs(basicDiff) > 0) {
            remarks.push({
                type: 'info',
                text: `💼 Salary Adjustment ${basicDiff > 0 ? '+' : ''}${basicDiff.toFixed(0)}%`,
                class: 'salaryAdjustment'
            });
        }

        // Basic absent deduction greater than 10% of salary
        const absentDeductionPercent = (item.basicAbsentDeduction / item.fullBasicSalary) * 100;
        if (absentDeductionPercent > 10) {
            remarks.push({
                type: 'check',
                text: `🏖️ ${absentDeductionPercent.toFixed(0)}% Absent Deduction`,
                class: 'absentDeduction'
            });
        }
    }

    // Net pay below 5% of basic salary
    const netPayPercent = (item.netPay / item.fullBasicSalary) * 100;
    if (netPayPercent < 5) {
        remarks.push({
            type: 'check',
            text: `⚠️ Net Pay ${netPayPercent.toFixed(1)}% of Basic`,
            class: 'deductionFloor'
        });
    }

    // Basic salary below 100
    if (item.fullBasicSalary < 100) {
        remarks.push({
            type: 'check',
            text: `💵 Basic Salary Below 100`,
            class: 'basicFloor'
        });
    }

    // Back pay days
    if (item.backPayDays > 0) {
        remarks.push({
            type: 'info',
            text: `Back Pay: ${item.backPayDays} days`,
            class: 'backPay'
        });
    }

    return remarks;
}


// function getTotalMonthDays(payrollDate) {
//     const m = moment(payrollDate)
//     return m.daysInMonth()
// }
function distributeEarnings( distEarning, previousState, settings) {
    // console.log({distEarnings})
    // const fullScale = {daysWorked: 'normalPayDays', hoursWorked:'monthlyHours', actualHoursWorked: 'monthlyHours' }
    if (distEarning) {
        
       
        const applicablePayrolls = (distEarning.appliesTo && previousState.payrolls.filter(p => distEarning.appliesTo.emps.includes(p.employeeId))) || []

        let total = 1;
        const additionalMembers = (distEarning.additionalMembers || 0);

        if (distEarning.basedOn === 'equalDistribution') {
            total = applicablePayrolls ? applicablePayrolls.length * distEarning.baseAmount : 1
        }
        else if (distEarning.basedOn === 'exactDistribution') {
            total = distEarning.baseAmount
        }

        else {
            total = applicablePayrolls ? applicablePayrolls.reduce((sum, cv) => sum + (cv[distEarning.basedOn] || 0), 0) : 0
            if (additionalMembers > 0 && applicablePayrolls && applicablePayrolls.length > 0) {
                const maxBasedOn = Math.max(...applicablePayrolls.map(p => p[distEarning.basedOn] || 0));
                total += maxBasedOn * additionalMembers;
            }
        }
            
            
        // console.log({total})
            
            
        const applicablePayrollsIds = applicablePayrolls.map(p => p.employeeId)
  
        if (distEarning.category === 'earnings') {
            // console.log(distEarning.appliesTo)

            if (distEarning.appliesTo.endDate && distEarning.totalTime > 0 && distEarning.basedOn !== 'equalDistribution') {
                //todo grab the actual total time from previous payrolls
                total = distEarning.totalTime
            }


            const payrollsWithDeductions = applicablePayrolls.filter(p => p.bonuses && p.bonuses.some(v => v.name && v.name.toLowerCase().replace(/\s+/g, '').includes(distEarning.name.toLowerCase().replace(/\s+/g, '')) && v.name.toLowerCase().replace(/\s+/g, '').includes('deduction')))
            const totalDeduction = payrollsWithDeductions.reduce((sum, cv) => sum + cv.bonuses.reduce((s, v) => {
                if (v.name.toLowerCase().replace(/\s+/g, '').includes(distEarning.name.toLowerCase().replace(/\s+/g, '')) && (v.name.toLowerCase().replace(/\s+/g, '').includes('deduction'))) {
                    // console.log("true",v.name)
                    return s + v.value
                }
                return s
            }, 0), 0)

            // const totalDistributed =  applicablePayrolls.reduce((sum,item)=>sum + distEarning.baseAmount/applicablePayrolls.length * (item[distEarning.basedOn]/item[fullScale[distEarning.basedOn]]),0)
            const payrollsWithDeductionsIds = payrollsWithDeductions.map(p => p.employeeId)
          
            // const earningDiff = distEarning.baseAmount - totalDistributed;
            // const fullPaidPayrolls = applicablePayrolls.filter(p=>p[distEarning.basedOn]===p[fullScale[distEarning.basedOn]]).map(p=>p.employeeId)



            // console.log({fullPaidPayrolls, earningDiff})
            //



            const res = previousState.payrolls.map(item => {

                let extraEarnings = item.bonuses


                // if (distEarning.appliesTo.emps.includes(item.employeeId)) {
                //
                //     extraEarnings = item.bonuses.filter(e=>e.name.toLowerCase().replace(/\s+/g, '')!==distEarning.name.toLowerCase().replace(/\s+/g, ''))
                //
                //
                //     let value = distEarning.baseAmount/applicablePayrolls.length * (item[distEarning.basedOn]/item[fullScale[distEarning.basedOn]])  //total ? (distEarning.baseAmount / total) * +item[distEarning.basedOn] : 0
                //     if(!payrollsWithDeductionsIds.includes(item.employeeId)){
                //         value += (-totalDeduction)/(applicablePayrolls.length-payrollsWithDeductionsIds.length)
                //     }
                //
                //    if(fullPaidPayrolls.includes(item.employeeId)) {
                //        value += earningDiff/fullPaidPayrolls.length
                //    }
                //
                //     // console.log({total,base:e.baseAmount,baseOn:item[e.basedOn], value})
                //     extraEarnings.push({type:distEarning.type, taxOption: distEarning.taxOption, value: +value.toFixed(2), name: distEarning.name})
                // }


                if (applicablePayrollsIds.includes(item.employeeId)) {
                    extraEarnings = item.bonuses.filter(e => e.name && e.name.toLowerCase().replace(/\s+/g, '') !== distEarning.name.toLowerCase().replace(/\s+/g, ''))

                    let value = 0

                    if (distEarning.basedOn === 'equalDistribution') {
                        value = distEarning.baseAmount / (applicablePayrolls.length + additionalMembers)
                    } else {
                    //  if(item[distEarning.basedOn]>0) {
                
                    const amount = distEarning.basedOn === 'exactDistribution' ? distEarning.baseAmount : +item[distEarning.basedOn]

                    value = total > 0 ? (distEarning.baseAmount / total) * amount : 0
                    // console.log({ value, distEarning, total, amount })

                    //  console.log("dist",item.distEarningsOnActualDate, "days",item)
                    if (distEarning.appliesTo.endDate) {
                        //todo grab the actual base from previous payrolls
                        // newbase = servicePayroll[distEarning.basedOn]
                        //  value = total ? (distEarning.baseAmount / total) * newBase : 0
                        //When distrubuting earnings like service charge with endDate set, use the actual date to proret, if set false it will only qualify based on hired month
                        const daysWorked = item.distEarningsOnActualDate ? moment(distEarning.appliesTo.endDate).diff(moment(item.startDate), "days") + 1 : item.totalWorkDays
                        const basePerDay = distEarning.basedOn === "serviceHours" ? item.dailyServiceHour : distEarning.basedOn === "daysWorked" ? 1 : amount / item.daysWorked

                        const newBase = daysWorked < item.totalWorkDays ? basePerDay * daysWorked : basePerDay * item.totalWorkDays

                        value = total ? (distEarning.baseAmount / total) * newBase : 0
                        //  const
                        //   console.log({workDays:item.totalWorkDays,daysWorked})
                        //    if(daysWorked<item.totalWorkDays) {
                        //       //newItem.serviceHours =  (newItem.daysWorked * newItem.dailyServiceHour)-(newItem.deductServiceHour?(newItem.missedHours||0):0)
                        //        const newBase = basePerDay * daysWorked
                        //
                        //    }
                        // console.log({daysWorked,value, total})
                    }

                    }

                    if (!payrollsWithDeductionsIds.includes(item.employeeId)) {
                        value += (-totalDeduction) / (applicablePayrolls.length - payrollsWithDeductions.length)
                    }
                    // console.log({total,base:e.baseAmount,baseOn:item[e.basedOn], value})
                    if (value > 0) {
                        extraEarnings.push({
                            type: distEarning.type,
                            taxOption: distEarning.taxOption,
                            value: +value.toFixed(2),
                            name: distEarning.name,

                        })
                    }
                }
                //  }




                // distEarnings.forEach(e => {
                //
                //     const total = e.appliesTo ? previousState.payrolls.filter(p => e.appliesTo.emps.includes(p.employeeId)).reduce((sum, cv) => sum + (cv[e.basedOn] || 0), 0) : 0
                //
                //
                //     if (e.appliesTo.emps.includes(item.employeeId)) {
                //
                //
                //         const value = total ? (e.baseAmount / total) * +item[e.basedOn] : 0
                //         // console.log({total,base:e.baseAmount,baseOn:item[e.basedOn], value})
                //         extraEarnings.push({taxOption: e.taxOption, value: +value.toFixed(2), name: e.name})
                //     }
                //
                // })
                // console.log({extraEarnings})
                return calculatePayrollItem(item, 'bonuses', extraEarnings, previousState.incomeTaxRules, settings, previousState.usedCurrencyRates)
            }
            );

            return res;
        }
     
        else if (distEarning && distEarning.category === 'expenses') {
            return previousState.payrolls.map(item => {

                let expenses = item.payrollFixedExpenses
              //  console.log({e:item.payrollF})

                if(applicablePayrollsIds.includes(item.employeeId)) {
                    expenses = item.payrollFixedExpenses.filter(e => e.name && e.name.toLowerCase().replace(/\s+/g, '') !== distEarning.name.toLowerCase().replace(/\s+/g, ''))
                    // console.log({expenses, e:item.payrollFixedExpenses})
                    let value = 0
                    if (distEarning.basedOn === 'equalDistribution') {
                        value = distEarning.baseAmount / (applicablePayrolls.length + additionalMembers)
                    } else {
                        const amount = distEarning.basedOn === 'exactDistribution' ? distEarning.baseAmount : +item[distEarning.basedOn]
                        value = total > 0 ? (distEarning.baseAmount / total) * amount : 0
                    }
                    if(value>0) {
                        expenses.push({
                            type: distEarning.type,
                            value: +value.toFixed(2),
                            originalValue:-1,
                            name: distEarning.name,
                        })
                    }
                }

              
                
                return calculatePayrollItem(item, 'payrollFixedExpenses', expenses, previousState.incomeTaxRules, settings,previousState.usedCurrencyRates)
          
          
          
            })
        }
        else return previousState.payrolls
    }
}

export default (previousState = initialState, { type, payload }) => {
    if (type === 'RESET_PAYROLL') {
        return {...initialState}
    }

    if (type === 'PAYROLL_LOADED') {
        return {...previousState,payrolls:payload};
    }
    if (type === 'PAYROLL_DATE_CHANGED') {

        let {payrollDate=previousState.payrollDate,periodStart=previousState.periodStart,periodEnd=previousState.periodEnd} = payload

        let startOfMonth = previousState.payrollDate
       // console.log({payload,startOfMonth,off:previousState.offsetDays})
        if(payrollDate!==previousState.payrollDate) {

            const today = moment(payrollDate).add(15, 'days')
            const todayEc = Zemen.toEC(today.get('year'), today.get('month'), today.get('date'))
             startOfMonth = previousState.calendar === 'EC' ? Zemen.toGC(todayEc.getFullYear(), todayEc.getMonth(), 1) : today.startOf('month').toDate()
            // const totalDaysInPayPeriod = previousState.periodDaySetting>0?previousState.periodDaySetting:moment(payrollDate).daysInMonth()
            const totalDaysInMonth = previousState.calendar === 'EC'?30:moment(payrollDate).daysInMonth()
            periodStart = moment(startOfMonth).add(previousState.offsetDays,'days').toDate();
            periodEnd = moment(periodStart).add(totalDaysInMonth-1,'days').set('h',23).set('minute',59).toDate()
            // console.log({totalDaysInPayPeriod, startOfMonth,periodStart,periodEnd})
            // periodEnd = previousState.periodDaySetting>0?moment(periodStart).add(previousState.periodDaySetting,'days'):moment(periodStart).add(moment(periodStart).daysInMonth(),'days').toDate()

             //console.log({payrollDate, startOfMonth})
            // periodStart = startOfMonth
            //  periodEnd = today.endOf('month').toDate()
        }
     //   const payrollDate =  payload.refresh?moment(previousState.payrollDate).toDate():startOfMonth;


        return {...previousState,payrollDate: startOfMonth, periodEnd, periodStart, prevPayrollDate: previousState.payrollDate};
    }
    if(type === 'PAYROLLS_SET_FIELD') {
        const {field,val,ids} = payload
        const payrolls = previousState.payrolls.map(p=>{
            if(ids&&ids.length>0&&ids.includes(p.employeeId)) {
                p = calculatePayrollItem(p, field, val, previousState.incomeTaxRules, previousState.settings, previousState.usedCurrencyRates)
            }
        
            return p
        })

        return {...previousState, payrolls,...calculatePayrollTotals(payrolls,previousState.site,previousState.employmentType,previousState.selectedStatus) }

    }


    if( type === 'DIST_EARNINGS_CHANGED') {
        const {distEarnings, apply, saveOnly} = payload
        // console.log({distEarnings,apply})

        if(saveOnly) {
            return {...previousState,distEarnings }

        }

        const data = distributeEarnings(apply,previousState,previousState.settings)
        // console.log("data",data)


        return {...previousState,distEarnings, payrolls: data,...calculatePayrollTotals(data,previousState.site,previousState.employmentType,previousState.selectedStatus) }
    }

    if( type === 'DIST_EARNINGS_REMOVED') {
        const {distEarnings, apply, saveOnly} = payload
        // console.log({apply})
        const applicablePayrollsIds = (apply.appliesTo && previousState.payrolls.filter(p => apply.appliesTo.emps.includes(p.employeeId))).map(p=>p.employeeId) || []


        const data =  previousState.payrolls.map(item=>{
           return  calculatePayrollItem(item, 'bonuses',  item.bonuses.filter(b=>  !applicablePayrollsIds.includes(item.employeeId)|| b.name!==apply.name), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
        })
        // console.log("data",data)


        return {...previousState,distEarnings, payrolls: data,...calculatePayrollTotals(data,previousState.site,previousState.employmentType,previousState.selectedStatus) }
    }

    if (type === 'CLEAR_PAYROLL') {
        return {...initialState}
    }

    if (type === 'GROUP_BONUS_CHANGED') {
        const {payrolls, fromMonth, toMonth} = payload
        console.log({payrolls})

        // const payrollLookup = Object.fromEntries(previousState.payrolls.map((p) => [p.employeeId, p]))


        const newPayrolls = previousState.payrolls.map(p=>{

            if(payrolls[p.employeeId]) {
                let bonuses = p.bonuses.filter(b=>(b.name).replace(/\s+/g, '').toLowerCase()==="annualbonus")

                const refPayroll = payrolls[p.employeeId]
                // console.log({refPayroll})
                const monthsSinceStart = moment(payload.lastDate).endOf('month').diff(moment(p.employee.startDate||"2015-01-01"),'month',true)
                console.log({monthsSinceStart})
                const monthsInBonusYear = Math.max(0, Math.min(monthsSinceStart - fromMonth, toMonth - fromMonth))
                // const monthPercentage = Math.max(1, monthsSinceStart/48)
                const effectiveRate = toMonth > fromMonth ? +refPayroll[0].bonusRate/(+refPayroll[0].bonusScale||1) *  monthsInBonusYear / (toMonth - fromMonth) : 0

                // console.log({monthsSinceStart,effectiveRate,bonusp,payload})
                bonuses.push({
                    type: 'bonus',
                    taxOption: 'NonTaxable',
                    value: effectiveRate * p.fullBasicSalary,
                    extraData:{collection:refPayroll.map(d=>({taxableIncome:d.taxableIncome, backpayPayroll:d.payrollRunId, incomeTax:d.incomeTax, payrollDate:d.payrollRun?d.payrollRun.payrollDate:new Date(2015,1,1)}))},
                    name: 'Annual Bonus'
                })

                p.bonusData = {
                    monthsInBonusYear,
                    bonusFactor:+refPayroll[0].bonusRate,
                    bonusScale:+refPayroll[0].bonusScale||1
                }

                return calculatePayrollItem(p, 'bonuses', bonuses, previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)

            }
            else return p;

        })


        return {...previousState, payrolls: newPayrolls,...calculatePayrollTotals(newPayrolls,previousState.site,previousState.employmentType,previousState.selectedStatus) }




    }

    if (type === 'PAYROLL_ITEM_CHANGED') {
        const {event} = payload
        //console.log(event.value)
        const editedItemID = event.dataItem.employeeId;
        const data = previousState.payrolls.map(item =>
           


           item.employeeId === editedItemID ? calculatePayrollItem(item,event.field,event.value,previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates) : item
       
       
           );

        return {...previousState,payrolls:data,...calculatePayrollTotals(data,previousState.site,previousState.employmentType,previousState.selectedStatus)};
    }

    // if( type==='PAYROLL_TIMESHEET_UPDATED') {
    //     const {timeSheets,idField,source} = payload
    //    // console.log(timeSheets)
    //     const lookup = {}

    //     for (let i = 0; i < timeSheets.length; i++) {
    //         if(timeSheets[i][idField]) {
    //             lookup[timeSheets[i][idField].toString().toLowerCase().replace(/\s+/g, '')] = timeSheets[i]
    //         }
    //         else {
    //             // console.log(timesheet[i])
    //         }
    //     }
        


    //    const data = previousState.payrolls.map(p=>{
    //        // console.log(p[idField],idField)

    //         if(p&&p[idField]&&p.status!=='Paid') {
    //             const timeSheet = lookup[p[idField].toString().toLowerCase().replace(/\s+/g, '')]
    //             if (timeSheet) {
    //                 // console.log({timeSheet})


    //                 if (timeSheet.ot&&(timeSheet.overtimes||timeSheet.overtimes===0)) {
    //                     p = calculatePayrollItem(p, 'overtimes', timeSheet.overtimes, previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)
    //                 }
    //                 if(!(p.absentDays>0&&timeSheet.absentDays<0)) {

    //                     if (timeSheet.absentDays>=0) {
    //                         // console.log(timeSheet.absentDays)
    //                         p = calculatePayrollItem(p, 'absentDays', timeSheet.absentDays, previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)

    //                         // if(p.normalPayDays<p.totalDaysInPayPeriod) {
    //                         //     const absent = timeSheet.absentDays//- (p.totalDaysInPayPeriod -p.normalPayDays)
    //                         //     p = calculatePayrollItem(p, 'absentDays', absent, previousState.incomeTaxRules, previousState.settings)
    //                         // }
    //                         // else {
    //                         //     p = calculatePayrollItem(p, 'absentDays', timeSheet.absentDays, previousState.incomeTaxRules,previousState.settings)
    //                         //
    //                         // }
    //                     }


    //                     if (timeSheet.monthlyHours || timeSheet.monthlyHours === 0) {
    //                         // console.log("ss",p.useServiceHours)
    //                         if (p.useServiceHours) {
    //                             // console.log("helloo")
    //                             p = calculatePayrollItem(p, 'monthlyHours', p.dailyServiceHour * Math.min(p.normalPayDays, p.daysInMonthForExpectedHours), previousState.incomeTaxRules, previousState.settings)
    //                         }

    //                             // else if(p.normalPayDays<p.totalDaysInPayPeriod)
    //                             // {
    //                             //     const reducedMonthlyHours = timeSheet.monthlyHours/p.totalDaysInPayPeriod *(p.normalPayDays-1)
    //                             //     p = calculatePayrollItem(p, 'monthlyHours', Math.floor(reducedMonthlyHours), previousState.incomeTaxRules)
    //                             //
    //                         // }
    //                         else {
    //                             p = calculatePayrollItem(p, 'monthlyHours', +(+timeSheet.monthlyHours).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
    //                         }
    //                     }
    //                     if (timeSheet.normalPayDays >= 0) {
    //                         p = calculatePayrollItem(p, 'normalPayDays', +timeSheet.normalPayDays, previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
    //                     }

    //                     if (timeSheet.missedHours || timeSheet.missedHours === 0) {
    //                         //  if(!(p.absentDays>0&&timeSheet.absentDays<0)) {
    //                         p = calculatePayrollItem(p, 'missedHours', +(+timeSheet.missedHours).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
    //                         // }
    //                     }

    //                     if (timeSheet.hoursWorked || timeSheet.hoursWorked === 0) {
    //                         if (p.useServiceHours) {
    //                             p = calculatePayrollItem(p, 'hoursWorked', +(p.monthlyHours - p.missedHours - (p.absentDays * p.dailyServiceHour)).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
    //                         } else {

    //                             p = calculatePayrollItem(p, 'hoursWorked', +(+timeSheet.hoursWorked).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)

    //                         }

    //                     }


    //                     if (source === "tik" && timeSheet.hoursWorked) {
    //                         p = calculatePayrollItem(p, 'fromTimeAttendance', +(+timeSheet.hoursWorked).toFixed(1), previousState.incomeTaxRules, previousState.settings,previousState.usedCurrencyRates)
    //                     }




    //                     if (timeSheet.penaltyAbsent>0) {
    //                         // console.log(timeSheet.absentDays)
    //                         p = calculatePayrollItem(p, 'penaltyAbsentDays', timeSheet.penaltyAbsent, previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)

    //                         // if(p.normalPayDays<p.totalDaysInPayPeriod) {
    //                         //     const absent = timeSheet.absentDays//- (p.totalDaysInPayPeriod -p.normalPayDays)
    //                         //     p = calculatePayrollItem(p, 'absentDays', absent, previousState.incomeTaxRules, previousState.settings)
    //                         // }
    //                         // else {
    //                         //     p = calculatePayrollItem(p, 'absentDays', timeSheet.absentDays, previousState.incomeTaxRules,previousState.settings)
    //                         //
    //                         // }
    //                     }


    //                 }

    //                 if(timeSheet.leaveDays||timeSheet.leaveDays===0) {p = calculatePayrollItem(p,'leaveDays',timeSheet.leaveDays,previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)}

    //                 if(timeSheet.transportPayableDays>=0) {
    //                     // if(!timeSheet.transportPayableDays>31){
    //                     //     console.log(p, timeSheet)
    //                     // }
    //                     // console.log(p, timeSheet)
    //                     const newEarnings = p.payrollFixedEarnings.slice(0); // Create a shallow copy of the roles
    //                     //const name = newRoles[index].name

    //                     const index = newEarnings.findIndex(e=>e.name.toLowerCase().replace(/\s+/g, '')==="transportallowance")
    //                     //console.log(index)
    //                     if(index>=0) {
    //                         const val = (newEarnings[index].originalValue / p.totalDaysInPayPeriod||30) * Math.min(p.totalDaysInPayPeriod,+timeSheet.transportPayableDays);

    //                         newEarnings[index] = {
    //                             ...newEarnings[index],
    //                             entitledDays:  Math.min(p.totalDaysInPayPeriod,+timeSheet.transportPayableDays),
    //                             fullValue: val,
    //                             value: val
    //                         }; // Set the new value
    //                         //console.log(newEarnings)
    //                         p = calculatePayrollItem(p,'payrollFixedEarnings',newEarnings,previousState.incomeTaxRules,previousState.settings)

    //                     }


    //                 }
    //                 if (timeSheet.actualHoursWorked||timeSheet.actualHoursWorked===0) {p = calculatePayrollItem(p,'actualHoursWorked',+(+timeSheet.actualHoursWorked).toFixed(1),previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)}

    //             }
    //         }

    //         return p;
    //     })

    //     return {...previousState,payrolls:data,...calculatePayrollTotals(data,previousState.site,previousState.employmentType,previousState.selectedStatus)};


    // }

    if( type==='PAYROLL_TIMESHEET_UPDATED') {
        const {data, unProccesedTimeSheet} = payload
       // console.log(timeSheets)
   

        return {...previousState,payrolls:data,unProccesedTimeSheet,...calculatePayrollTotals(data,previousState.site,previousState.employmentType,previousState.selectedStatus )};


    }

    if( type==='PAYROLL_EARNINGS_DEDUCTIONS_UPDATED') {
        const {items,idField,deductionTypes, earningTypes} = payload

        // console.log(items)
        // const lookup = {}
        //
        // for (let i = 0; i < items.length; i++) {
        //     if(items[i][idField]) {
        //         lookup[items[i][idField].toString().toLowerCase()] = items[i]
        //     }
        //     else {
        //         // console.log(timesheet[i])
        //     }
        // }
        const lookup = _.groupBy(items, idField);
        // console.log({lookup})

        const data = previousState.payrolls.map(p=>{

            if(p&&p[idField]&&p.status!=='Paid') {
                const items = lookup[p[idField].toString().toLowerCase()]
                // console.log({items})
                items&&items.forEach(item=>{
                    if (item) {
                        // console.log({item})
                        if(item.category==='deduction')
                        {
                            const t = (item.type && deductionTypes.find(t=>t.type.toLowerCase().replace(/\s+/g, '')===item.type.toLowerCase().replace(/\s+/g, '')))||{type:'other', name:'Other', cash:true}
                            const deductions  = (p.payrollDeductions||[]).slice(0); // Create a shallow copy of the roles
                            const index = deductions.findIndex(e=>e.name.toLowerCase().replace(/\s+/g, '')===item.name.toLowerCase().replace(/\s+/g, ''))
                            if(index<0) {
                                deductions.push({
                                    type: t.type,
                                    name: item.name || t.name,
                                    cash: item.cash || t.cash,
                                    value: +item.value
                                })
                            }
                            else {
                                const updated = {...deductions[index], value: +item.value}
                                if(item.type) {
                                    updated.type = t.type
                                }
                                if(item.name) {
                                    updated.name = item.name
                                }
                                if(item.cash!==undefined&&item.cash!==null&&item.cash!=='') {
                                    updated.cash = item.cash
                                }
                                deductions[index] = updated
                            }


                            p = calculatePayrollItem(p,'payrollDeductions',deductions,previousState.incomeTaxRules,previousState.settings,previousState.usedCurrencyRates)

                        }

                        if(item.category==='earning')
                        {
                            // console.log(item)

                            const t = (item.type && earningTypes.find(t=>t.id.toLowerCase().replace(/\s+/g, '')===item.type.toLowerCase().replace(/\s+/g, '')))||{id:'other', name:item.name||'Other Earning', taxOption: "Taxable"}
                            if(item.extraData && (item.type==='shiftAllowance'||item.type==='onCallAllowance')) {
                                item.value =  (p.fullBasicSalary)/(p.monthlyOTHours)*item.extraData.shiftRate * item.extraData.shiftHour
                            }
                            const v = (t&&t.name.toLowerCase().includes('deduction'))?-Math.abs(+item.value):+item.value
                            const earnings  = (p.bonuses||[]).slice(0); // Create a shallow copy of the earnings

                            const index = earnings.findIndex(e=>e.name.toLowerCase().replace(/\s+/g, '')===item.name.toLowerCase().replace(/\s+/g, ''))
                            if(index<0) {
                                earnings.push({
                                    type: t.id,
                                    extraData: item.extraData,

                                    name: item.name || t.name,
                                    taxOption: item.taxOption || t.taxOption,
                                    value: v
                                })
                            }
                            else {
                                const updated = {...earnings[index], value: v}
                                if(item.type) {
                                    updated.type = t.id
                                }
                                if(item.name) {
                                    updated.name = item.name
                                }
                                if(item.taxOption) {
                                    updated.taxOption = item.taxOption
                                }
                                if(item.extraData) {
                                    updated.extraData = item.extraData
                                }
                                earnings[index] = updated
                            }
                            // console.log(earnings)


                            p = calculatePayrollItem(p,'bonuses',earnings,previousState.incomeTaxRules,previousState.settings, previousState.usedCurrencyRates)

                        }
                    }

                })

            }

            return p;
        })

        return {...previousState,payrolls:data,...calculatePayrollTotals(data,previousState.site,previousState.employmentType,previousState.selectedStatus)};


    }


if (type === 'PAYROLL_SITE_CHANGED') {
    const {site} = payload




    return {...previousState,site,description:site||previousState.employmentType||previousState.selectedStatus?`Only ${site?`${site} `:''} ${previousState.employmentType?previousState.employmentType:''} ${previousState.selectedStatus?previousState.selectedStatus:''} Employees`:'',...calculatePayrollTotals(previousState.payrolls,site,previousState.employmentType,previousState.selectedStatus,previousState.costCenter)};
}
if (type === 'PAYROLL_REGION_CHANGED') {
    const {region} = payload

    return {...previousState,region,description:region||previousState.site||previousState.employmentType||previousState.selectedStatus?`Only ${previousState.site?`${previousState.site} `:''} ${region?`${region} `:''} ${previousState.employmentType?previousState.employmentType:''} ${previousState.selectedStatus?previousState.selectedStatus:''} Employees`:'',...calculatePayrollTotals(previousState.payrolls,previousState.site,previousState.employmentType,previousState.selectedStatus,previousState.costCenter)};
}
    if (type === 'PAYROLL_CURRENCY_CHANGED') {
        console.log(payload)
        return {...previousState, usedCurrencyRates:payload.usedCurrencyRates}
    }
    if (type === 'PAYROLL_STATUS_CHANGED') {
        const {status} = payload



        return {...previousState,selectedStatus:status,description:status||previousState.employmentType||previousState.site?`Only ${previousState.site?`${previousState.site} `:''} ${previousState.employmentType?previousState.employmentType:''}  ${status?status:''} Employees`:'',...calculatePayrollTotals(previousState.payrolls,previousState.site,previousState.employmentType,status)};
    }
    if (type === 'PAYROLL_EMPLOYMENT_TYPE_CHANGED') {
        const {employmentType} = payload
        return {...previousState,employmentType,description:previousState.site||previousState.selectedStatus||employmentType?`Only ${previousState.site?`${previousState.site} `:''} ${employmentType?employmentType:''}  ${previousState.selectedStatus?previousState.selectedStatus:''} Employees`:'',...calculatePayrollTotals(previousState.payrolls,previousState.site,employmentType,previousState.selectedStatus,previousState.costCenter)};
    }
    if (type === 'PAYROLL_COST_CENTER_CHANGED') {
        const {costCenter} = payload

        // const payrolls = previousState.map(p=>{
        //     // console.log(p.costCenterCosts)
        //     if(costCenter&&p.costCenterItems&&p.costCenterItems.length){
        //         const cs = p.costCenterItems.find(c=>c.costCenterCode===costCenter)
        //         // console.log(cs)
        //         if(cs) {
        //             p.cash = cs.cash
        //             p.costCenterCode = cs.costCenterCode
        //             p.totalIncome = cs.totalIncome
        //             p.netPay= cs.netPay
        //             p.incomeTax = cs. incomeTax
        //             p.taxableIncome = cs.taxableIncome
        //         }
        //     }
        //     return p
        // })

        return {...previousState,costCenter,description:previousState.site||previousState.selectedStatus||costCenter?`Only ${previousState.site?`${previousState.site} `:''} ${costCenter?costCenter:''}  ${previousState.selectedStatus?previousState.selectedStatus:''} Employees`:'',...calculatePayrollTotals(previousState.payrolls,previousState.site,previousState.employmentType,previousState.selectedStatus,costCenter)};
    }
    if (type === 'PAYROLL_DESCRIPTION_CHANGED') {
        const {description} = payload
        return {...previousState,description};
    }
    if (type === 'PAYROLL_EXPAND_CHANGED') {
        const {event} = payload
        const editedItemID = event.dataItem.employeeId;
        const data = previousState.payrolls.map(item =>
            item.employeeId === editedItemID ? {...item, expanded: !event.dataItem.expanded} : item
        );
        return {...previousState,payrolls:data};
    }

    if(type === 'PAYROLLRUN_LOADED_FOR_MERGE'){
        const {payrollRun} = payload
        if(payrollRun.site) {
            const newPayrolls = payrollRun.payrolls.filter(p => p.siteName === payrollRun.site)
            const payrolls = previousState.payrolls.filter(p=>p.siteName !== payrollRun.site).concat(newPayrolls)
            // console.log(newPayrolls)
            return {...previousState, site:null, description:`Merged with ${payrollRun.site}`,  payrolls: payrolls,...calculatePayrollTotals(payrolls) }

        }

    }

//     if (type === 'PAYROLL_EMPLOYEES_LOADED') {
//     // console.log('root',payload.currencyState)
//     if(payload.employees)
//     {
//        // const incomeTaxRules = payload.incomeTaxRules.data.map(r=>({r.}))
//         const incomeTaxRules  = payload.incomeTaxRules.data.map(r=>(({ start, end,taxRate,deduction }) => ({ start, end,taxRate,deduction }))(r))
//
//         const contractEndEmployees = payload.employees.data.filter(e=>{
//            const endDate = new Date(new Date(e.contractEndDate).getFullYear(),new Date(e.contractEndDate).getMonth())
//             const payRollDate = new Date(new Date().getFullYear(),new Date().getMonth())
//             //          // endDate.set('')
//            return e.employmentType==="Contract" && endDate < payRollDate
//         } )
//
//         const filterIds = contractEndEmployees.map(e=>e.id);
//         const payrollData = payload.employees.data.filter(e=>!filterIds.includes(e.id)).map(e => {
//
//         // const commonDeductions=    payload.company.data.payrollFixedDeductions.map(d => {
//         //     const  value = d.valueType === 'Percentage'? d.value* e.basicSalary : d.value;
//         //     return {...d,value}
//         // })
//
//      const deductions =  e.deductions.filter(d=>!d.cash).map(d=>{
//               const  value = d.valueType === 'Percentage'? d.value* e.basicSalary : d.value;
//               const rest =  (({deductionType,name,scope,templateId}) => ({deductionType,name,scope,templateId }))(d);
//              return {...rest,value}
//      })
//
//      const cashDeductions =  e.deductions.filter(d=>d.cash).map(d=>{
//                 const  value = d.valueType === 'Percentage'? d.value* e.basicSalary : d.value;
//                 const rest =  (({deductionType:type,name,cash,ref,templateId}) => ({type,name,cash,ref,templateId }))(d);
//                 rest.remaining = getRemaining(rest.ref,e.loans,value)
//                  rest.estimatedMonth = Math.ceil(getRemaining(rest.ref,e.loans,value)/value)
//                 return {...rest,value}
//             });
//             const earnings=  e.earnings.map(d=>{
//                 const value= d.valueType === 'Percentage'? d.value* e.basicSalary : d.value;
//                 const rest =  (({limitByValue,name,taxOption,scope,earningType, templateId}) => ({limitByValue,name,taxOption,scope,earningType, templateId }))(d);
//                 return {...rest,value}
//             })
//
//
//             const expenses = e.expenses.map(d=>{
//                 const  value = d.valueType === 'Percentage'? d.value* e.basicSalary : d.value;
//                 const rest =  (({type,name,scope, templateId}) => ({type,name,scope, templateId }))(d);
//                 return {...rest,value}
//             })
//
//
//
//            // console.log('expenses',expenses)
//
//
//             const empPension = deductions.reduce((sum,cv)=>cv.deductionType === 'EmpPension'? sum+cv.value:sum,0)
//             const companyPension = expenses.reduce((sum,cv)=>cv.type === 'CompanyPension'? sum+cv.value:sum,0)
//             const pf = deductions.reduce((sum,cv)=>cv.deductionType === 'PF'? sum+cv.value:sum,0)
//             const companyPf= expenses.reduce((sum,cv)=>cv.type === 'CompanyPF'? sum+cv.value:sum,0)
// const leave = e.leaves.find(l=>l.typeId===1 && l.year===new Date().getFullYear() );
//            // console.log(payrollFixedDeductions)
// const monthyDaysSetting = payload.company.data.companySettings.find(s=>s.name==="Payroll_WorkingDays");
//             const monthyHoursSetting = payload.company.data.companySettings.find(s=>s.name==="Payroll_MonthlyHours");
//             const monthlyHoursForOT = payload.company.data.companySettings.find(s=>s.name==="Payroll_MonthlyHoursOT");
//             const deductTransportIfAbsent = payload.company.data.companySettings.find(s=>s.name==="Payroll_DeductTransportIfAbsent");
//
//
//             const bank = payload.banks.data.find(b=>b.id===e.companyBankId)
//      const fatherName = (!!e.fatherName)? e.fatherName: ''
//             const payroll = {
//             employeeId:e.id,
//             orgID: e.orgID,
//                 mateId: e.mateId,
//                 employmentType: e.employmentType,
//            // employee: e,
//             name:e.name,
//             positionName:e.position&&e.position.name,
//                 siteName:(e.site&&e.site.name)||'',
//             jobLevelName: (e.position&&e.position.jobLevel&&e.position.jobLevel.name)||'',
//              departmentName: (e.position&&e.position.department&&e.position.department.name)||'',
//             fullName: e.name + ' '+ fatherName +  ' ' + (!!e.gFatherName? e.gFatherName: ''),
//             bank: (bank && bank.bank) ? bank.bank.name : "",
//             bankBranch: e.bankBranch,
//             bankAccountNumber: e.bankAccountNumber,
//             tinNo:e.tinNo,
//             basicSalary: e.basicSalary,
//             overtimes: [],
//             bonuses: [],
//             additionalFixedEarnings: earnings.reduce((sum, cv) => sum + cv.value, 0),
//             fixedDeductionsTotals: deductions.reduce((sum, cv) => sum + cv.value, 0),
//             fixedExpensesTotals: expenses.reduce((sum, cv) => sum + cv.value, 0),
//             payrollFixedDeductions: deductions,
//             payrollFixedExpenses: expenses,
//             payrollFixedEarnings: earnings,
//             payrollDeductions: cashDeductions, //advances/loan or others
//             totalWorkDays: monthyDaysSetting?monthyDaysSetting.value : 26, //get from database
//             monthlyHours: monthyHoursSetting?monthyHoursSetting.value: 196, //get from database
//             monthlyOTHours: monthlyHoursForOT?monthlyHoursForOT.value: 208,
//              absentDays: 0,
//            leaveDays: 0,
//             daysWorked: monthyDaysSetting?monthyDaysSetting.value : 26,
//             hoursWorked: monthyHoursSetting?monthyHoursSetting.value: 196,
//            deductTransportIfAbsent: deductTransportIfAbsent?deductTransportIfAbsent.value==="true":false,
//             empPension,
//             companyPension,
//             pf,
//             companyPf,
//             leaveDaysTaken:(leave && leave.daysTaken)||0,
//              leaveDaysTakenPrevious:(leave && leave.daysTaken)||0,
//             leaveDaysEntitled:(leave && leave.entitledDays)||0,
//             prevOutstandingLoan: e.outstandingLoan,
//             outstandingLoan:e.outstandingLoan,
//             loans:e.loans,
//         }
//
//         return calculatePayrollItem(payroll,'calculated',true,incomeTaxRules)
//
//     })
//        // console.log(payload.currencyRate)
//         return {...previousState,runDate:new Date(),payrollDate: new Date(),payrolls:payrollData,...calculatePayrollTotals(payrollData,previousState.site),incomeTaxRules,currencyRateId:payload.currencyRate[0].id};
//
//     }
//

    function getWorkDays(totalDaysInPayPeriod, e, payrollStartDate, payrollEndDate, restDaysToSkip, initialNotes, payrollDate) {
        // Check for suspension events first
        if (e.events && e.events.length > 0) {
            var suspensions = e.events.filter(function(event) {
                return !event.cancelled &&
                    event.eventType === 'Suspension' &&
                    (!event.startDate || moment(event.startDate).isBefore(moment(payrollEndDate))) &&
                    (!event.endDate || moment(event.endDate));
            });
            if (suspensions.length > 0) {
                // Find the earliest start and latest end date
                var startDates = suspensions.map(function(s) { return s.startDate ? moment(s.startDate) : null; }).filter(Boolean);
                var endDates = suspensions.map(function(s) { return s.endDate ? moment(s.endDate) : null; }).filter(Boolean);
                var suspensionStart = startDates.length > 0 ? startDates.reduce(function(a, b) { return a.isBefore(b) ? a : b; }) : null;
                var suspensionEnd = endDates.length > 0 ? endDates.reduce(function(a, b) { return a.isAfter(b) ? a : b; }) : null;
                var startDate = moment.max(moment(payrollStartDate, 'YYYY-MM-DD'), moment(e.startDate, 'YYYY-MM-DD')).startOf('day');
                var endDate = moment(e.contractEndDate) > moment('1970-01-01') ? moment.min(moment(payrollEndDate), moment(e.contractEndDate, 'YYYY-MM-DD')) : moment(payrollEndDate).startOf('day');
                var totalDays = endDate.diff(startDate, 'days') + 1;
                // Uniform, inclusive overlap calculation
                var actualSuspensionStart = suspensionStart && suspensionStart.isSameOrAfter(startDate, "day") ? suspensionStart : startDate;
                var actualSuspensionEnd = suspensionEnd && suspensionEnd.isBefore(endDate) ? suspensionEnd : endDate;
                var suspendedDays = 0;
                if (actualSuspensionStart && actualSuspensionEnd && actualSuspensionStart.isSameOrBefore(actualSuspensionEnd)) {
                    suspendedDays = actualSuspensionEnd.diff(actualSuspensionStart, 'days') + 1;
                }
                var payableDays = totalDays - suspendedDays;
                if (payableDays < 0) payableDays = 0;
                // Add a note about the actual interval used
                if (initialNotes && suspendedDays > 0) {
                    initialNotes.push({
                        note: 'Suspension from ' + (startDates.length > 0 ? suspensionStart.format('DD/MM/YYYY') : '-') + ' to ' + (endDates.length > 0 ? suspensionEnd.format('DD/MM/YYYY') : '-') + ', payable days: ' + payableDays + ' suspended days: ' + suspendedDays,
                        noteField: 'suspension',
                        noteType: 'Suspension',
                        noteBy: 'System',
                        employeeId: e.id,
                        payrollDate: payrollDate,
                        noteDate: new Date().toISOString()
                    });
                }
                return payableDays;
            }
        }
        // If no suspension, proceed with normal calculation
        var startDate = moment.max(moment(payrollStartDate, 'YYYY-MM-DD'), moment(e.startDate, 'YYYY-MM-DD')).startOf('day');
        var endDate = moment(e.contractEndDate) > moment('1970-01-01') ? moment.min(moment(payrollEndDate), moment(e.contractEndDate, 'YYYY-MM-DD')) : moment(payrollEndDate).startOf('day');
        var totalDays = moment(payrollEndDate).diff(moment(payrollStartDate), 'days') + 1;
        var workedDays = endDate > startDate ? endDate.diff(startDate, 'days') + 1 : 0;
        if (restDaysToSkip && workedDays < totalDays) {
            return countDaysBetween(startDate, endDate, restDaysToSkip);
        } else {
            return workedDays;
        }
    }

    // function convertCurrency(value,defaultCurrency='etb') {
    //     //console.log(payload.currencyRate)
    //     return value * ((payload.usedCurrencyRates)[defaultCurrency.toLowerCase()]) / ((payload.usedCurrencyRates)['etb']);
    //
    // }
//     }
    if (type === 'PAYROLL_EMPLOYEES_LOADED') {
       


        const calendarSetting = payload.company.data.companySettings.find(s=>s.name==="Payroll_Calendar");

        const calendar = (calendarSetting&&calendarSetting.value) || 'GC';
        const today = moment.utc().add(-15, 'days')

            const todayEc =   Zemen.toEC(today.get('year'),today.get('month'),today.get('date'))
        const startOfMonth = calendar==='EC'?Zemen.toGC(todayEc.getFullYear(),todayEc.getMonth(),1):today.startOf('month').toDate()
        // console.log({startOfMonth})

        const lastMonthPayroll = payload.lastMonthPayroll.data[0];
        const lastMonthPayrollsLookup =  lastMonthPayroll ? Object.fromEntries(lastMonthPayroll.payrolls.map((p) => [p.employeeId, _.pick(p,['cash', 'netPay', 'basicSalary', 'fullBasicSalary', 'totalIncome', 'salaryInBasicCurrency'])])) : {}
      
        // console.log({lastMonthPayrollsLookup, lastMonthPayroll})


        const payrollDate = payload.refresh ? moment(previousState.payrollDate).toDate() : startOfMonth;
        const usedCurrencyRates = payload.refresh ? previousState.usedCurrencyRates : payload.usedCurrencyRates

        const monthyDaysSetting = payload.company.data.companySettings.find(s=>s.name==="Payroll_WorkingDays");
        const periodDaySetting = payload.company.data.companySettings.find(s=>s.name==="Payroll_PayPeriodDays");
        const absentDeductionAfterTaxSetting = payload.company.data.companySettings.find(s=>s.name==="absentDeductionAfterTax");
        const absentDeductionDesiredNetSetting = payload.company.data.companySettings.find(s=>s.name==="absentDeductionDesiredNet");

        const monthyHoursSetting = payload.company.data.companySettings.find(s=>s.name==="Payroll_MonthlyHours");
        const monthlyHoursForOT = payload.company.data.companySettings.find(s=>s.name==="Payroll_MonthlyHoursOT");
        const deductTransportIfAbsent = payload.company.data.companySettings.find(s=>s.name==="Payroll_DeductTransportIfAbsent");

        const useServiceHoursSetting = payload.company.data.companySettings.find(s=>s.name==="useServiceHour");
        const deductServiceHourSetting = payload.company.data.companySettings.find(s=>s.name==="deductServiceHour");
        const distEarningsOnActualDateSetting = payload.company.data.companySettings.find(s=>s.name==="distEarningsOnActualDate");

        const ignoreLeaveOnServiceHoursSetting = payload.company.data.companySettings.find(s=>s.name==="ignoreLeaveOnServiceHours");

        const daysInMonthForOTSetting = payload.company.data.companySettings.find(s=>s.name==="daysInMonthForOT");
        const daysInMonthForExpectedHoursSetting =   payload.company.data.companySettings.find(s=>s.name==="daysInMonthForExpectedHours");
        const settingFullMonth=  payload.company.data.companySettings.find(s=>s.name==='Pension_FullMonth')
        const StartFullMonth = settingFullMonth?settingFullMonth.value==='true':true
        const restDaysToSkipSetting = payload.company.data.companySettings.find(s=>s.name&&s.name.toLowerCase()==="restdaystoskip");
        const actingAllowancePercentageSetting = payload.company.data.companySettings.find(s=>s.name==="actingAllowancePercentage");
        const restDaysToSkip = restDaysToSkipSetting&&restDaysToSkipSetting.value&&restDaysToSkipSetting.value.split(',')
        // const omitTransportAllowance = false

        const absentDeductionAfterTax = absentDeductionAfterTaxSetting?absentDeductionAfterTaxSetting.value==='true':false
        const absentDeductionDesiredNet = absentDeductionDesiredNetSetting?absentDeductionDesiredNetSetting.value==='true':false

        const offsetDaysSetting = payload.company.data.companySettings.find(s=>s.name==="Payroll_Start_Offset");
        const offsetDays = +(offsetDaysSetting&&offsetDaysSetting.value) || 0;
        const startNewTaxRuleAfterDaysSetting = payload.company.data.companySettings.find(s=>s.name==="startNewTaxRuleAfterDays");

        const startNewTaxRuleAfterDays = startNewTaxRuleAfterDaysSetting&&startNewTaxRuleAfterDaysSetting.value?startNewTaxRuleAfterDaysSetting.value:0
        // console.log({useServiceHoursSetting})

        const totalDaysInPayPeriod = periodDaySetting&&(periodDaySetting.value>0)?+periodDaySetting.value : moment(payrollDate).daysInMonth();
        const totalDaysInMonth = calendar==='EC'?30:moment(payrollDate).daysInMonth();
        const useServiceHours = useServiceHoursSetting&&useServiceHoursSetting.value==='true'
        const ignoreLeaveOnServiceHours = ignoreLeaveOnServiceHoursSetting &&ignoreLeaveOnServiceHoursSetting.value==='true'
        const deductServiceHour = deductServiceHourSetting&&deductServiceHourSetting.value==='true'
        //When distrubuting earnings like service charge with endDate set, use the actual date to proret, if set false it will only qualify based on hired month
        const distEarningsOnActualDate = distEarningsOnActualDateSetting&&distEarningsOnActualDateSetting.value==='true'

        const daysInMonthForOT = (daysInMonthForOTSetting&&daysInMonthForOTSetting.value) || 26
        const daysInMonthForExpectedHours = (daysInMonthForExpectedHoursSetting&&daysInMonthForExpectedHoursSetting.value) || 26
        const actingAllowancePercentage = (actingAllowancePercentageSetting&&actingAllowancePercentageSetting.value) || 100

        // const payrollStartDate = payload.refresh&&moment(previousState.prevPayrollDate).format('YYYY-MM')===moment(payrollDate).format('YYYY-MM')?moment(previousState.periodStart).toDate():moment(payrollDate).add(offsetDays,'days');
        // const payrollEndDate = payload.refresh&&moment(previousState.prevPayrollDate).format('YYYY-MM')===moment(payrollDate).format('YYYY-MM')?moment(previousState.periodEnd).toDate():moment(payrollStartDate).add(totalDaysInPayPeriod-1,'days').set('h',23)


        const payrollStartDate = payload.refresh?moment(previousState.periodStart).toDate():moment(payrollDate).add(offsetDays,'days').toDate();
        const payrollEndDate = payload.refresh?moment(previousState.periodEnd).toDate():moment(payrollStartDate).add(totalDaysInMonth-1,'days').set('h',23).set('minute',59).toDate()


        const fullWorkDays = monthyDaysSetting&&(monthyDaysSetting.value>0)?monthyDaysSetting.value : moment(payrollDate).daysInMonth();
        const fullMonthlyHours = (monthyHoursSetting?monthyHoursSetting.value||0: 196)



        const site = payload.refresh?previousState.site:null;
        const description = payload.refresh?previousState.description:null;
        const employmentType = payload.refresh?previousState.employmentType:null;
        const region = payload.refresh?previousState.region:null;

        const settings = {absentDeductionAfterTax, absentDeductionDesiredNet, startNewTaxRuleAfterDays, lastMonthPayrollFound: !!lastMonthPayroll}

        const costCenerLookup = {}
        payload.costCenters.data.forEach(c=>{
            costCenerLookup[c.id] = c
        })

        //console.log('root',payload)
        if(payload.employees)
        {
            // const incomeTaxRules = payload.incomeTaxRules.data.map(r=>({r.}))
            const incomeTaxRules  = payload.incomeTaxRules.data.map(r=>(({ start, end,taxRate,deduction }) => ({ start, end,taxRate,deduction }))(r))

            // const filteredEmployeesByDate = payload.employees.data.filter(e=>{
            //     const startDate =  new Date(new Date(e.startDate).getFullYear(),new Date(e.startDate).getMonth())
            //     const endDate = e.employmentType!=="FullTime" && new Date(new Date(e.contractEndDate).getFullYear(),new Date(e.contractEndDate).getMonth())
            // //     console.log(startDate)
            //     const payRollMonth = new Date(payrollDate.getFullYear(),payrollDate.getMonth())
            //     //          // endDate.set('')
            //
            //  //   return e.employmentType==="Contract" && (startDate > payRollMonth || endDate < payRollMonth)
            //     return startDate > payRollMonth || (endDate && endDate < payRollMonth)
            //
            //
            // } )

      //      const filterIds = filteredEmployeesByDate.map(e=>e.id);
            const payrollData = payload.employees.data.filter(e=>{
            //    console.log(moment(e.contractEndDate).toDate(),"?",payrollStartDate.toDate())
                // console.log(e.contractEndDate,e.startDate)
               return (!e.startDate || moment(e.startDate) <= moment(payrollEndDate)) && (!e.contractEndDate || moment(e.contractEndDate)<moment("1970/1/1") ||  moment(e.contractEndDate) >= moment(payrollStartDate))

            }).map(e => {

                const initialNotes = []

          

                const prevPayroll = payload.refresh && previousState.payrolls.find(p => p.employeeId === e.id)
                // console.log('prevPayroll',prevPayroll)

                // const commonDeductions=    payload.company.data.payrollFixedDeductions.map(d => {
                //     const  value = d.valueType === 'Percentage'? d.value* e.basicSalary : d.value;
                //     return {...d,value}
                // })
                e.startDate = e.startDate || moment("1970/1/1")
                e.contractEndDate = e.contractEndDate || moment("3000/1/1")


                      const lastMonthPay = lastMonthPayrollsLookup[e.id]
                let defaultBackPayDays = 0

                if(lastMonthPayroll && !lastMonthPay) {
                    // console.log({date: e.startDate, last:moment(payrollEndDate).subtract(1, 'month') })

                    // if start date lies in the previous month, set defaultBackPayDays from startDate to end of previous month
                    // Account for varying month lengths by using endOf('month') for GC calendar
                   if(moment(e.startDate) < moment(payrollEndDate).subtract(1, 'month') && moment(e.startDate) > moment(payrollStartDate).subtract(1, 'month') ) {
                    const prevMonthEnd = calendar === 'EC' 
                        ? moment(payrollEndDate).subtract(1, 'month') // EC: each month is 30 days, subtract preserves end date
                        : moment(payrollEndDate).subtract(1, 'month').endOf('month'); // GC: use actual end of month
                    defaultBackPayDays = prevMonthEnd.diff(moment(e.startDate), 'days') + 1;
                   }


                }

                if(defaultBackPayDays > 0) {
                    initialNotes.push({
                        note: `Back Pay Days calculated from ${moment(e.startDate).format("MMM DD, YYYY")}: ${defaultBackPayDays} days`,
                        noteField: 'backPayDays',
                        noteType: 'BackPay',
                        noteBy: 'System',
                        employeeId: e.id,
                        payrollDate: payrollDate,
                        noteDate: new Date().toISOString()
                    });
                }


                
                //currency conversion
                // console.log({e})
                let fullBasicSalary =  convertCurrency(e.basicSalary,e.basicCurrency||e.defaultCurrency,usedCurrencyRates)/// e.basicSalary * ((payload.currencyRate)[e.defaultCurrency.toLowerCase()]) / ((payload.currencyRate)['etb']);



                const totalWorkDays = Math.min(fullWorkDays,getWorkDays(totalDaysInPayPeriod,e,payrollStartDate,payrollEndDate,restDaysToSkip,initialNotes, payrollDate));
                const payDays = getWorkDays(totalDaysInPayPeriod,e,payrollStartDate,payrollEndDate,restDaysToSkip)
                
                if (e.newBasicSalaryStartDate&&moment(e.newBasicSalaryStartDate).isSameOrAfter(moment(payrollStartDate), 'day')) {
                   
                const newBasicStartDate = moment(e.newBasicSalaryStartDate).startOf('day');
                const prevBasicSalary = convertCurrency(e.prevBasicSalary, e.basicCurrency||e.defaultCurrency, usedCurrencyRates);
                
                // Calculate days before new basic salary start date
                const daysBeforeNewBasic = Math.min(
                    getWorkDays(totalDaysInPayPeriod, e, payrollStartDate, newBasicStartDate.clone().subtract(1, 'day'), restDaysToSkip),
                    totalDaysInPayPeriod    
                );
                
                // Calculate days after new basic salary start date
                const daysAfterNewBasic = Math.max(0, totalDaysInPayPeriod - daysBeforeNewBasic);
                
                    // console.log({daysBeforeNewBasic,daysAfterNewBasic, prevBasicSalary, basicSalary:e.basicSalary})
                // Calculate basic salary based on days before and after new basic start date
                fullBasicSalary = (
                    (prevBasicSalary / totalDaysInPayPeriod * daysBeforeNewBasic) +
                    (fullBasicSalary / totalDaysInPayPeriod * daysAfterNewBasic)
                )
                    
                initialNotes.push({
                    note: `Salary adjusted from ${e.basicCurrency||e.defaultCurrency}${e.prevBasicSalary}  to ${e.basicCurrency||e.defaultCurrency}${e.basicSalary}  starting ${newBasicStartDate.format('DD/MM/YYYY')}. prev salary days: ${daysBeforeNewBasic},  new salary days: ${daysAfterNewBasic}`,
                    noteField: 'fullBasicSalary',
                    noteType: 'SalaryAdjustment',
                    noteBy: 'System', 
                    employeeId: e.id,
                    payrollDate: payrollDate,
                    noteDate: new Date().toISOString()
                });
                    
                    
                   
                }


                if(e.employeeAdjustments) {
                    e.employeeAdjustments.forEach(a => {
                        
                        if (a.effectiveDate && moment(a.effectiveDate).isSameOrAfter(moment(payrollStartDate), "day")) {    
                            
                            if (a.adjustmentType === 'Salary') {
                              
                                const newBasicStartDate = moment(a.effectiveDate).startOf('day');
                                //   console.log({newBasicStartDate, date:newBasicStartDate.format('DD/MM/YYYY')})
                                const prevBasicSalary = convertCurrency(a.oldValue, a.currency||e.defaultCurrency, usedCurrencyRates);
                                const newBasicSalary =  convertCurrency(a.value, a.currency||e.defaultCurrency, usedCurrencyRates);

                                const daysBeforeNewBasic = Math.min(
                                    getWorkDays(totalDaysInPayPeriod, e, payrollStartDate, newBasicStartDate.clone().subtract(1, 'day'), restDaysToSkip),
                                    totalDaysInPayPeriod    
                                );
                                // console.log({prevBasicSalary})
                                // Calculate days after new basic salary start date
                                const daysAfterNewBasic = Math.max(0, totalDaysInPayPeriod - daysBeforeNewBasic);
                                
                                    // console.log({daysBeforeNewBasic,daysAfterNewBasic, prevBasicSalary, basicSalary:e.basicSalary})
                                // Calculate basic salary based on days before and after new basic start date
                                fullBasicSalary = (
                                    (prevBasicSalary / totalDaysInPayPeriod * daysBeforeNewBasic) +
                                    (newBasicSalary / totalDaysInPayPeriod * daysAfterNewBasic)
                                )
                                    
                                initialNotes.push({
                                    note: `Salary adjusted from ${e.basicCurrency||e.defaultCurrency}${a.oldValue}  to ${e.basicCurrency||e.defaultCurrency}${a.value}  starting ${newBasicStartDate.format('DD/MM/YYYY')}. prev salary days: ${daysBeforeNewBasic},  new salary days: ${daysAfterNewBasic}, reason ${a.description||''} - ${a.remarks||''} `,
                                    noteField: 'fullBasicSalary',
                                    noteType: 'SalaryAdjustment',
                                    noteBy: 'System', 
                                    employeeId: e.id,
                                    payrollDate: payrollDate,
                                    noteDate: new Date().toISOString()
                                });
                                // console.log({initialNotes})
                            }

                            if(a.adjustmentType==='Site') {
                                const site = payload.sites.data.find(s=>s.id===a.value)
                                if(site) {
                                    e.siteId = site.id
                                }
                            }


                        }
                    })
                }
                

                let basicSalary = e.employmentType!=="Casual"?(+(fullBasicSalary / totalDaysInPayPeriod )* getWorkDays(totalDaysInPayPeriod,e,payrollStartDate,payrollEndDate).toFixed(5)):fullBasicSalary
                
             //   basicSalary = basicSalary + (prevPayroll&&prevPayroll.basicSalaryAdjustment?convertCurrency(prevPayroll.basicSalaryAdjustment,e.basicCurrency,usedCurrencyRates):0)
       
                
                
                const costCenterCosts = []

                const freshDeductions =  e.deductions.filter(d=>!d.cash&&d.value).map(d=>{
                    const val = d.valueType === 'Percentage'? d.value* fullBasicSalary : convertCurrency(d.value,e.defaultCurrency, usedCurrencyRates);
                    let startDate = moment(d.startDate||'1,1,1')

                    let value = val
                    //const now = moment(payrollDate).endOf('month')
                    const diff = moment(payrollEndDate).diff(startDate,'day')//+1
                  //  console.log(diff,'diff')

                    if( diff<totalDaysInPayPeriod) {
                      //  if(!StartFullMonth) {
                            value = diff <= 0 ? 0 : (d.deductionType==="EmpPension"&&StartFullMonth)? value : (value / totalDaysInPayPeriod) * (diff + 1)
                       // }
                    }
                    const rest =  (({deductionType,name,scope,templateId, valueType }) => ({deductionType,name,scope,templateId, valueType }))(d);
                    return {...rest,dayBased:d.valueType === 'Percentage'?true:d.dayBased, value,fullValue:value, originalValue:val}
                })


                // console.log({deductions})

                const cashDeductions =  e.deductions.filter(d=>d.cash&&d.value).map(d=>{
                    let  value = d.valueType === 'Percentage'? d.value* fullBasicSalary : convertCurrency(d.value,e.defaultCurrency,usedCurrencyRates);

                    if(prevPayroll){

                        const deduct = prevPayroll.payrollDeductions.find(de=>de.ref && d.ref && de.ref === d.ref )

                        if(deduct){

                            value = deduct.value
                        }
                    }

                    const rest =  (({deductionType:type,name,cash,ref,templateId,dayBased, valueType, currency }) => ({type,name,cash,ref,templateId,dayBased, valueType, currency }))(d);

                    if(d.costCenterId&&d.costCenterId!==e.costCenterId) {
                        const costCenter = costCenerLookup[d.costCenterId]
                        if(costCenter) {
                            costCenterCosts.push({
                                costCenterId: d.costCenterId,
                                costCenterCode: costCenter.code,
                                name: d.name,
                                type: 'Deduction',
                                value
                            })
                            rest.costCenterCode = costCenter.code
                        }
                    }


                   const remain = getRemaining(rest.ref,e.loans)
                    if(d.ref) {
                        value = Math.min(value, remain)
                    }
                    rest.remaining = remain - value
                    rest.estimatedMonth = Math.ceil( +(rest.remaining/value).toFixed(5))
                    return {...rest,value}
                });

                const freshEarnings = e.earnings.map(d => {
                    
                    if(d.basedOn==='site'&&payload.sites){
                        const site = payload.sites.data.find(s=>s.id===e.siteId)
                        if (site) {

                            d.value = site.allowanceValue
                            
                     
                            
                        
                        }
                    }
                    if (d.basedOn === 'region' && payload.regions) {
                        const site = payload.sites.data.find(s => s.id === e.siteId) || {}
                        const region = payload.regions.data.find(r => r.id === site.regionId)
                        // console.log({site,region})
                        if(region){
                            d.value = region.allowanceValue || 0
                        }
                    }
                    let value= d.valueType === 'Percentage'? d.value* fullBasicSalary : d.valueType === 'Hour'?fullBasicSalary/(monthlyHoursForOT.value||208)*+d.value: convertCurrency(d.value,d.currency||e.defaultCurrency,usedCurrencyRates);
                    const newValue = value;
                    if(d.basedOn&&e.employeeAdjustments) {
                        const adjustments = e.employeeAdjustments.filter(a=>a.effectiveDate&&moment(a.effectiveDate).isSameOrAfter(moment(payrollStartDate),'day')&&a.adjustmentType==='Site')
                    //   console.log({adjustments})
                        adjustments && adjustments.forEach(a => {
                            const oldSite = payload.sites.data.find(s => s.id === a.oldValue)
                            let oldAllowanceValue = oldSite ? oldSite.allowanceValue || 0 : 0;
                            if(d.basedOn==='region') {
                                const region = payload.regions.data.find(r => r.id === oldSite.regionId)
                                oldAllowanceValue = region ? region.allowanceValue || 0 : 0;
                            }

                            const oldValue = d.valueType === 'Percentage'? oldAllowanceValue * fullBasicSalary : d.valueType === 'Hour'?fullBasicSalary/(monthlyHoursForOT.value||208)*+oldAllowanceValue: convertCurrency(oldAllowanceValue,d.currency||e.defaultCurrency,usedCurrencyRates);


                             const daysBeforeNewAllowance = Math.min(
                                getWorkDays(totalDaysInPayPeriod, e, payrollStartDate, moment(a.effectiveDate).subtract(1, 'day'), restDaysToSkip),
                                totalDaysInPayPeriod    
                             );
                            // console.log({daysBeforeNewAllowance})
                             const daysAfterNewAllowance = Math.max(0, totalDaysInPayPeriod - daysBeforeNewAllowance);
                         
                            
                            value = (oldValue / totalDaysInPayPeriod * daysBeforeNewAllowance) + (newValue / totalDaysInPayPeriod * daysAfterNewAllowance)

                            // const data = [{
                            //     site: oldSite,
                            //     value: (oldValue / totalDaysInPayPeriod * daysBeforeNewAllowance),
                            //     days: daysBeforeNewAllowance
                            // }, {
                            //     site: e.site,
                            //     value: (newValue / totalDaysInPayPeriod * daysAfterNewAllowance),
                            //     days: daysAfterNewAllowance
                            // }];
                      
                            initialNotes.push({
                                note: `${d.name} adjusted from ${oldValue}  to ${newValue} starting ${moment(a.effectiveDate).format('DD/MM/YYYY')}. prev days: ${daysBeforeNewAllowance},  new days: ${daysAfterNewAllowance}`,
                                noteField: 'allowance',
                                employeeId: e.id,
                                payrollDate: payrollDate,
                                noteType: 'AlowanceAdjustment',
                                noteBy: 'System', 
                                noteDate: new Date().toISOString()
                            });
                                
                      
                        })
                    }



                    
                    const rest =  (({limitByValue,name,taxOption,scope,earningType, templateId,dayBased, showOriginal, valueType, currency }) => ({limitByValue,name,taxOption,scope,earningType, templateId,dayBased,showOriginal, valueType, currency }))(d);
                    if(d.costCenterId&&d.costCenterId!==e.costCenterId) {
                        const costCenter = costCenerLookup[d.costCenterId]
                       if(costCenter) {
                           costCenterCosts.push({
                               costCenterId: d.costCenterId,
                               costCenterCode: costCenter.code,
                               name: d.name,
                               type: 'Earnings',
                               taxOption: rest.taxOption,
                               value
                           })
                           rest.costCenterCode = costCenter.code
                       }
                    }

                    return {...rest,dayBased:d.valueType === 'Percentage'?true:d.dayBased,value:value, originalValue:value, fullValue:value, refId:d.id}
                })

                // if(costCenterCosts.length) {
                //     costCenterCosts.push({costCenterId:d.costCenterId, costCenterCode:costCenter.code, name:d.name, type:'Earnings', taxOption:rest.taxOption,
                //
                //     }

                const freshExpenses  = e.expenses.map(d=>{


                    if( d.type && d.type.toLowerCase().replace(/\s+/g, '')==='terminationbenefit') {
                    // Calculate years of service for termination benefit
                    const startDate = moment(e.startDate||"1,1,1").add(-1, 'days').startOf('day');
                    const currentDate = moment(payrollStartDate).add(15, 'days').startOf('day');
                    const yearsOfService = currentDate.diff(startDate, 'years', true);
             
                    // Apply termination benefit calculation rule:
                    // If less than one year of service, use 1/12 factor
                    // Otherwise, use 1/36 factor
                    d.value  = yearsOfService <= 1 ? 1/12 : 1/36;

                    // if employee is on suspension set daybased to false
                    const isSuspended =  isSuspendedDuringPayroll(e, payrollStartDate, payrollEndDate);

                    d.dayBased =  !isSuspended; // Set dayBased to false if suspended

             
                                    
                    }
                     
                    

                    const  val = d.valueType === 'Percentage'? d.value* fullBasicSalary: convertCurrency(d.value,e.defaultCurrency,usedCurrencyRates);
                    const startDate = moment(d.startDate||'1,1,1')
                    let value = val
                  
                  //  const now = moment(payrollDate).endOf('month')
                    const diff = moment(payrollEndDate).diff(startDate,'day')

                    // if( diff<totalDaysInPayPeriod) {
                    //     value = diff<=0? 0 :(value / totalDaysInPayPeriod) * (diff+1)
                    // }
                    if( diff<totalDaysInPayPeriod) {
                        //  if(!StartFullMonth) {
                        value = diff <= 0 ? 0 : (d.type==="CompanyPension"&&StartFullMonth)? value : (value / totalDaysInPayPeriod) * (diff + 1)
                        // }
                    }

                    const rest =  (({type,name,scope, templateId,dayBased, valueType, currency }) => ({type,name,scope, templateId,dayBased, valueType, currency }))(d);
                     if(d.costCenterId&&d.costCenterId!==e.costCenterId) {
                        const costCenter = costCenerLookup[d.costCenterId]
                       if(costCenter) {
                           costCenterCosts.push({
                               costCenterId: d.costCenterId,
                               costCenterCode: costCenter.code,
                               name: d.name,
                               type: 'Expenses',
                               value
                           })
                           rest.costCenterCode = costCenter.code
                       }
                    }
                    return {...rest,dayBased:d.dayBased, value,fullValue:value, originalValue:val}
                })



                // console.log('expenses',expenses)


                // const empPension = deductions.reduce((sum,cv)=>cv.deductionType === 'EmpPension'? sum+cv.value:sum,0)
                // const companyPension = expenses.reduce((sum,cv)=>cv.type === 'CompanyPension'? sum+cv.value:sum,0)
                // const pf = deductions.reduce((sum,cv)=>cv.deductionType === 'PF'? sum+cv.value:sum,0)
                // const companyPf= expenses.reduce((sum,cv)=>cv.type === 'CompanyPF'? sum+cv.value:sum,0)
                const leave = e.leaves.find(l=>l.typeId===1 && l.year===new Date().getFullYear() );
                // console.log(payrollFixedDeductions)




                const bank = payload.banks.data.find(b=>b.id===e.companyBankId)

                // const fatherName = (
                const fullName =   e.name + ' '+ (!!e.fatherName? e.fatherName: '')  +  ' ' + (!!e.gFatherName? e.gFatherName: '')  //e.fullname serach is not woorking on runpayroll



                // if(e.id===262) {
                //     console.log(prevPayroll)
                // }
            //    const prevPayDays = prevPayroll && getWorkDays(totalDaysInPayPeriod,prevPayroll.em,payrollDate)


                const addedDeductions = prevPayroll?_.differenceWith(prevPayroll.payrollDeductions,cashDeductions,(a,b)=>(a.ref && b.ref && a.ref===b.ref)||(a.name===b.name&&a.value===b.value)).filter(b=>!b.ref):[]
                  // if(e.id===271) {
                  //     console.log({addedDeductions,prevPayroll,cashDeductions})
                  // }


                const earnings = freshEarnings.map(e=>{
                    const prevEarning = prevPayroll&&prevPayroll.payrollFixedEarnings.find(fe=>fe.name===e.name)
                    let value = e.value;
                   let name = e.name;
                    let fullValue = e.fullValue;
                   let  entitledDays = payDays;
                    if(prevEarning&&(prevEarning.originalValue||+prevEarning.originalValue===0)&&prevEarning.originalValue!==prevEarning.fullValue)
                    {
                       value = prevEarning.value;
                       fullValue = prevEarning.value;
                       entitledDays = prevEarning.entitledDays
                       name = prevEarning.name;

                    }
                    return {...e,value, name,fullValue,entitledDays}
                })


                const deductions = freshDeductions.map(e=>{
                    // console.log(e)
                    const prevEarning = prevPayroll&&prevPayroll.payrollFixedDeductions.find(fe=>fe.name===e.name)
                    let value = e.value;
                   let name = e.name;
                    let fullValue = e.fullValue;
             
                    if(prevEarning&&(prevEarning.originalValue||+prevEarning.originalValue===0)&&prevEarning.originalValue!==prevEarning.fullValue)
                    {
                       value = prevEarning.value;
                       fullValue = prevEarning.value;
                       name = prevEarning.name;

                    }
                    return {...e,value, name,fullValue}
                })

                const expenses = freshExpenses.map(e => {
                    const prevEarning = prevPayroll && prevPayroll.payrollFixedExpenses.find(fe => fe.name === e.name);
                    let value = e.value;
                    let name = e.name;
                    let fullValue = e.fullValue;
                
                    if (prevEarning && (prevEarning.originalValue || +prevEarning.originalValue === 0) && prevEarning.originalValue !== prevEarning.fullValue) {
                        value = prevEarning.value;
                        fullValue = prevEarning.value;
                        name = prevEarning.name;
                    }
                
                    return { ...e, value, name, fullValue };
                });
                
                // if (prevPayroll) {
                //     const filteredPrev = prevPayroll.payrollFixedExpenses.filter(e => e.originalValue === -1);
                //     const filteredFresh = freshExpenses.filter(fe => !prevPayroll.payrollFixedExpenses.some(pe => pe.originalValue === -1 && pe.name === fe.name));
                //     expenses.unshift(...filteredPrev);
                //     expenses.splice(filteredPrev.length, 0, ...filteredFresh);
                // }

                const normalPayDays = prevPayroll && prevPayroll.originalPayDays && prevPayroll.originalPayDays!==prevPayroll.normalPayDays?prevPayroll.normalPayDays:payDays
                const dailyServiceHour =  (prevPayroll &&prevPayroll.dailyServiceHour!==((prevPayroll.employee&&prevPayroll.employee.dailyServiceHour)||8))?prevPayroll.dailyServiceHour : ((!!e.dailyServiceHour||e.dailyServiceHour===0)?e.dailyServiceHour:8)
                const monthlyHours =  e.employmentType!=="Casual"?(!useServiceHours?fullMonthlyHours*normalPayDays/totalDaysInPayPeriod:dailyServiceHour*(Math.min(normalPayDays,daysInMonthForExpectedHours))):normalPayDays*dailyServiceHour; //get from database
// console.log({id:e.id, monthlyHours, normalPayDays})
                // console.log(previousState.payrollDate.toDate(),payrollDate)
                // console.log(prevPayroll&&prevPayroll.daysWorked,getWorkDays(monthyDaysSetting,e,previousState.payrollDate.toDate()))
                //console.log({e})

                
                
const payrollCostCenterAllocations = e.employeeCostCenterAllocations.map(c=>{
    const costCenter = costCenerLookup[c.costCenterId]
    return { costCenterCode: costCenter&&costCenter.code, allocationPercentage:c.allocationPercentage, remarks:c.remarks, costCenterId:c.costCenterId,costCenterName:costCenter&&costCenter.name}
})




if(settings.startNewTaxRuleAfterDays>0) {
     

    const cuttOffDays = (normalPayDays !== totalDaysInPayPeriod && moment(e.startDate) > moment("07-01-2025"))?  Math.max(0,moment("07-01-2025").add(settings.startNewTaxRuleAfterDays, 'days').diff(moment(e.startDate), 'days')): settings.startNewTaxRuleAfterDays
    
    // console.log({cuttOffDays, name: newItem.employee.name})


if(cuttOffDays!=settings.startNewTaxRuleAfterDays||normalPayDays !== totalDaysInPayPeriod)
 { initialNotes.push({
                                note: `Income Tax:  ${cuttOffDays} Days with old rule and ${normalPayDays-cuttOffDays} Days with new Rule `,
                                noteField: 'incomeTax',
                                employeeId: e.id,
                                payrollDate: payrollDate,
                                noteType: 'IncomeTaxAdjustment',
                                noteBy: 'System', 
                                noteDate: new Date().toISOString()
                            });}
//  console.log({oldIncomeTax, new:newItem.incomeTax })

}



                const payroll = {
                    employeeId:e.id,
                    orgID: e.orgID,
                    mateId: e.mateId,
                    employmentType: e.employmentType,
                    employee: e,
                    startDate: e.startDate,
                    contractEndDate: e.contractEndDate,
                    name: e.name,
                    basicCurrency: e.basicCurrency,
                    program: e.program,
                    salaryInBasicCurrency: e.basicSalary, // in case of currency conversion
                    positionName:e.position&&e.position.name,
                    siteName: (e.site && e.site.name) || '',
                    regionName: (e.site && e.site.region && e.site.region.name) || '',
                    jobLevelName: (e.position&&e.position.jobLevel&&e.position.jobLevel.name)||'',
                    departmentName: (e.department&&e.department.name)||(e.position&&e.position.department&&e.position.department.name)||'',
                    costCenterCode: e.costCenter&&(e.costCenter.code||e.costCenter.name),
                    //  employeementTypeName: (e.position&&e.position.department&&e.position.department.name)||'',

                    fullName,
                    emailAddress:e.address&&e.address.email,
                    bank: (bank && bank.bank) ? bank.bank.name : "",

                    bankBranch: e.bankBranch,
                    bankAccountNumber: e.bankAccountNumber,
                    bankAccountHolderName: e.bankAccountHolderName||fullName,
                    pensionNo: e.pensionNo,
                    tinNo:e.tinNo,
                    fullBasicSalary,
                    overtimes: (prevPayroll &&prevPayroll.overtimes) || [],
                    bonuses: (prevPayroll &&prevPayroll.bonuses) || [],
                    additionalFixedEarningsOriginal: earnings.reduce((sum, cv) => sum + cv.originalValue, 0),
                    additionalFixedEarnings: earnings.reduce((sum, cv) => sum + cv.value, 0),
                    fixedDeductionsTotals: deductions.reduce((sum, cv) => sum + cv.value, 0),
                    fixedExpensesTotals: expenses.reduce((sum, cv) => sum + cv.value, 0),
                    payrollFixedDeductions: deductions,
                    payrollFixedExpenses: expenses,
                    payrollFixedEarnings: earnings,
                    payrollDeductions:  cashDeductions.concat(addedDeductions), //advances/loan or others
                    totalWorkDays, //get from database
                    totalDaysInPayPeriod,
                    fullWorkDays,
                    fullMonthlyHours,
                    monthlyHours:  (prevPayroll && prevPayroll.originalPayDays===payDays &&prevPayroll.monthlyHours) || monthlyHours ,//: monthyHoursSetting?monthyHoursSetting.value: 196, //get from database
                    monthlyOTHours: !useServiceHours?monthlyHoursForOT?monthlyHoursForOT.value: 208:Math.min(11,dailyServiceHour)*daysInMonthForOT,
                    absentDays: (prevPayroll &&prevPayroll.absentDays) || 0,
                    penaltyAbsentDays: (prevPayroll &&prevPayroll.penaltyAbsentDays) || 0,
                    leaveDays: (prevPayroll && prevPayroll.leaveDays) || 0,
                    notes: (prevPayroll && prevPayroll.notes && prevPayroll.notes.length>0)?[...prevPayroll.notes.filter(n=>n.noteBy!=="System"),...initialNotes]:initialNotes,
                    daysWorked: (prevPayroll &&prevPayroll.daysWorked) || totalWorkDays,// getWorkDays(monthyDaysSetting,e,payrollDate),
                    serviceDays: (prevPayroll && prevPayroll.serviceDays != null) ? prevPayroll.serviceDays : totalWorkDays + (ignoreLeaveOnServiceHours?((prevPayroll && prevPayroll.leaveDays) || 0):0),//newItem.daysWorked + (newItem.ignoreLeaveOnServiceHours?newItem.leaveDays:0)
                    serviceDaysModified: !!(prevPayroll && prevPayroll.serviceDays != null && prevPayroll.serviceDays !== ((prevPayroll.daysWorked || 0) + (ignoreLeaveOnServiceHours?((prevPayroll.leaveDays)||0):0))),
                    payDays,
                    originalPayDays: payDays,
                    normalPayDays:normalPayDays,
                    hoursWorked: prevPayroll &&prevPayroll.normalPayDays=== normalPayDays ? prevPayroll.hoursWorked : monthlyHours,
                    actualHoursWorked: prevPayroll &&prevPayroll.actualHoursWorked !== prevPayroll.monthlyHours ? prevPayroll.actualHoursWorked : monthlyHours,
                    serviceHours:(prevPayroll && prevPayroll.serviceHours != null) ? prevPayroll.serviceHours : totalWorkDays*dailyServiceHour,
                    dailyServiceHour,
                    useServiceHours,
                    ignoreLeaveOnServiceHours,
                    deductServiceHour,
                    distEarningsOnActualDate,
                    daysInMonthForOT,
                    daysInMonthForExpectedHours,
                    deductTransportIfAbsent: (prevPayroll &&prevPayroll.deductTransportIfAbsent) ||(deductTransportIfAbsent?deductTransportIfAbsent.value==="true":false),
                    omitTransportAllowance: (prevPayroll &&prevPayroll.omitTransportAllowance) || false,
                    // empPension,
                    // companyPension,d
                    // pf,
                    // companyPf,
                    leaveDaysTaken:(leave && leave.daysTaken)||0,
                    leaveDaysTakenPrevious:(leave && leave.daysTaken)||0,
                    leaveDaysEntitled:(leave && leave.entitledDays)||0,
                    prevOutstandingLoan: Math.max(e.outstandingLoan,0),
                    outstandingLoan:Math.max(e.outstandingLoan,0),
                    loans:e.loans,
                    basicSalary,
                    basicSalaryAdjustment: (prevPayroll && prevPayroll.basicSalaryAdjustment) || 0,
                    defaultBackPayDays,
                    backPayDays: (prevPayroll && defaultBackPayDays !== prevPayroll.defaultBackPayDays )? defaultBackPayDays : (prevPayroll && prevPayroll.backPayDays) || defaultBackPayDays,
                    forwardPayDays:(prevPayroll && prevPayroll.forwardPayDays) || 0,
                    fromTimeAttendance: (prevPayroll && prevPayroll.fromTimeAttendance) || 0,
                    status: (prevPayroll && prevPayroll.status) || "Processing",
                    payrollDate:payrollDate,
                    periodDaySetting:periodDaySetting&&+periodDaySetting.value,
                    payGross: e.payGross || false,
                    otBase: e.otBase || 'basic',
                    desiredNet: e.desiredNet,
                    excludeFromDistEarnings:  e.excludeFromDistEarnings,
                    costCenterCosts,
                    extraIncomeTax: (prevPayroll && prevPayroll.extraIncomeTax) || e.extraIncomeTax || 0,
                    customIncomeTaxExpression: e.customIncomeTaxExpression,
                    payrollCostCenterAllocations,
                    function: e.function,
                    grade: e.grade,
                    step: e.step,
                    lastMonthPay:lastMonthPay,
                }

                // if (e.events && e.events.length > 0) {
                //     const suspensions = e.events.filter(event => 
                //         event.eventType === 'Suspension' && 
                //         moment(event.startDate).isSameOrBefore(moment(payrollStartDate)) &&
                //         (!event.endDate || moment(event.endDate).isAfter(moment(payrollEndDate)))
                //     )
                //     // console.log({suspensions})
                    
                //     if (suspensions.length > 0) {
                //         payroll.status = 'Held'
                //         payroll.notes.push({
                //             note: `Employee is on suspension from ${suspensions[0].startDate?moment(suspensions[0].startDate).format('DD/MM/YYYY'):'-'} to ${suspensions[0].endDate?moment(suspensions[0].endDate).format('DD/MM/YYYY'):'-'}`,
                //             noteField: 'Suspension',
                //             employeeId: e.id,
                //             payrollDate: payrollDate,
                //             noteType: 'Suspension',
                //         noteBy: 'System', 
                //         noteDate: new Date()
                //     })
                //     }
                // }

                // const payroll = prevPayroll;
                // payroll.payrollDeductions = cashDeductions//.concat(addedDeductions)
                // payroll.loans =  e.loans


                // console.log('payroll',payroll)
                return calculatePayrollItem(payroll, 'calculated', true, incomeTaxRules, settings, usedCurrencyRates)

            })
            const excluded = payload.employees.data.filter(e=>!payrollData.map(p=>p.employeeId).includes(e.id))
            // console.log({excluded})
            // console.log(payload.currencyRate)
            //console.log("date",previousState.payrollDate)
            // console.log(payload.refresh,previousState.distEarnings)
            const distEarnings = payload.refresh?previousState.distEarnings||[]: (payload.company.data.defaultDistEarnings||[]).map(e=>({...e,appliesTo:{...e.appliesTo,
                    emps:payrollData.filter(p=>!p.excludeFromDistEarnings&&e.appliesTo.groups.map(g=>g.toLowerCase()).includes(p.siteName.toLowerCase())&&(!e.appliesTo.endDate||moment(p.startDate)<=moment(e.appliesTo.endDate))).
                    map(p=>p.employeeId)

            }}))
            console.log({previousState})
            // console.log(distEarnings,payload.company.data.defaultDistEarnings)
            // const withDistEarnings = distributeEarnings(distEarnings,{...previousState,payrolls:payrollData,incomeTaxRules})

            if (payload.isSelectedRefresh && previousState.payrolls && previousState.payrolls.length > 0) {
                const selectedIds = new Set(payload.selectedEmployeeIds || []);
                const existingMap = {};
                previousState.payrolls.forEach(p => { existingMap[p.employeeId] = p; });

                const mergedPayrolls = [...previousState.payrolls.filter(p => !selectedIds.has(p.employeeId)), ...payrollData];

                return {...previousState, payrolls: mergedPayrolls, ...calculatePayrollTotals(mergedPayrolls, previousState.site, previousState.employmentType, previousState.selectedStatus), usedCurrencyRates};
            }

             

            return {...previousState, excluded, settings,   site,description,employmentType,region,runDate:new Date(),payrollDate:moment(payrollDate), periodStart:payrollStartDate, periodEnd:payrollEndDate, calendar, distEarnings, payrolls:payrollData,...calculatePayrollTotals(payrollData,previousState.site,previousState.employmentType,previousState.selectedStatus),incomeTaxRules,currencyRateId:payload.currencyRate.id,usedCurrencyRates, firstRun: !payload.refresh, offsetDays, periodDaySetting:(periodDaySetting?+periodDaySetting.value||0:0), useServiceHours, ignoreLeaveOnServiceHours, deductServiceHour, daysInMonthForOT,daysInMonthForExpectedHours,distEarningsOnActualDate,actingAllowancePercentage};

        }

    }
    if(type==='PAYROLLRUN_DATA_LOADED') {
        // console.log(payload.payrollRun)
        if(payload.payrollRun) {
            // console.log(payload.payrollRun)
          //  return calculatePayrollItem(payload.payrollRun,'calculated',true,incomeTaxRules)
            if(payload.payrollRun.remarks && payload.payrollRun.remarks.length) {
            const remarkNotes = payload.payrollRun.remarks.reduce((acc, remark) => {
                if (remark.payrollNotes && remark.payrollNotes.length) {
                    const notes = remark.payrollNotes.map(note => ({
                        ...note,
                        payrollId: note.payrollId,
                        employeeId: note.employeeId, // may be undefined for old notes
                        note: note.note,
                        remarkUser: remark.user,
                        remarkDate: remark.date,
                        remarkType: remark.type,
                        remarkId: remark._id
                    }));
                    return [...acc, ...notes];
                }
                return acc;
            }, []);

            if(remarkNotes && remarkNotes.length)
               {
                const lookUpPayrolls = payload.payrollRun.payrolls.reduce((acc, p) => {
                    acc[p.id] = p;
                    acc[p.employeeId] = p;
                    return acc;
                }, {});
                remarkNotes.forEach(n=>{
                    // Prefer employeeId on the note, else look up by payrollId
                    const empId = n.employeeId || (lookUpPayrolls[n.payrollId] && lookUpPayrolls[n.payrollId].employeeId);
                    if (empId && lookUpPayrolls[empId]) {
                        if (!lookUpPayrolls[empId].reviewNotes) {
                            lookUpPayrolls[empId].reviewNotes = [];
                        }
                        lookUpPayrolls[empId].reviewNotes.push(n);
                    }
                })
               }

            } 
            // console.log( payload)
             return {...previousState, ...payload.payrollRun}
        }
    }
    if(type==='PAYROLLRUN_SET_FIRST_RUN') {
        // if(payload.payrollRun) {
        //     //  return calculatePayrollItem(payload.payrollRun,'calculated',true,incomeTaxRules)
        //     return {...payload.payrollRun}
        // }
        return {...previousState, firstRun: payload}
    }
    if (type === 'LOAD_SAVED_PAYROLL_STATE') {
        if (payload) {
            // Defensive: ensure all date fields are valid
            let payrollDate = payload.payrollDate;
            if (!payrollDate || (typeof payrollDate === 'object' && payrollDate._isAMomentObject)) {
                payrollDate = moment(payrollDate);
            } else {
                payrollDate = moment(new Date(payrollDate));
            }
            let periodStart = payload.periodStart;
            if (!(periodStart instanceof Date)) {
                periodStart = new Date(periodStart);
            }
            let periodEnd = payload.periodEnd;
            if (!(periodEnd instanceof Date)) {
                periodEnd = new Date(periodEnd);
            }
            const parsedState = {
                ..._.omit(payload, 'savedOn', 'savedBy', 'companyId', 'autosaved', 'checkpointId'),
                payrollDate,
                periodStart,
                periodEnd
            };
            // Merge saved state with current state to ensure we have all required fields
            return {
                ...previousState,
                ...parsedState,
                ...calculatePayrollTotals(
                    parsedState.payrolls,
                    parsedState.site,
                    parsedState.employmentType,
                    parsedState.selectedStatus
                )
            };
        }
        return previousState;
    }
    // if (type === 'PAYROLL_CHECKPOINT_SAVED') {
    //     // Only checkpoint summaries are stored in Redux, not full checkpoint objects
    //     return {
    //         ...previousState,
    //         checkpoints: payload.checkpoints.map(cp => ({
    //             checkpointId: cp.checkpointId,
    //             payrollDate: cp.payrollDate,
    //             savedBy: cp.savedBy,
    //             savedOn: cp.savedOn,
    //             autosaved: cp.autosaved,
    //             companyId: cp.companyId
    //         })) || []
    //     };
    // }
    // if (type === 'PAYROLL_CHECKPOINTS_LOADED') {
    //     // Only checkpoint summaries are stored in Redux, not full checkpoint objects
    //     return {
    //         ...previousState,
    //         checkpoints: payload.checkpoints || []
    //     };
    // }
    return previousState;
}
